import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LightingDataService {
  items = [
    {
      "partNumber": "10020",
      "description": "C-STAND W/ GRIP HEAD & 40” ARM"
    },
    {
      "partNumber": "10040",
      "description": "LOW C-STAND W/ GRIP HEAD & 20” ARM"
    },
    {
      "partNumber": "10060",
      "description": "MINI-BASE LO C-STAND W' HEAD & 20” ARM"
    },
    {
      "partNumber": "10120",
      "description": "GRIP COMBO HEAD/LOLLIPOP"
    },
    {
      "partNumber": "10130",
      "description": "GRIP COMBO HEAD/LOLLIPOP CNTR MOUNT"
    },
    {
      "partNumber": "10140",
      "description": "GRIP HEAD 2-1/2”"
    },
    {
      "partNumber": "10150",
      "description": "60' EXTENSION ARM"
    },
    {
      "partNumber": "10160",
      "description": "40” EXTENSION ARM"
    },
    {
      "partNumber": "10170",
      "description": "30” EXTENSION ARM"
    },
    {
      "partNumber": "10180",
      "description": "20” EXTENSION ARM"
    },
    {
      "partNumber": "10200",
      "description": "HI HI ROLLER (7')"
    },
    {
      "partNumber": "10220",
      "description": "MED. HI-ROLLER (6')"
    },
    {
      "partNumber": "10240",
      "description": "HI ROLLER (5')"
    },
    {
      "partNumber": "10260",
      "description": "LOW COMBO"
    },
    {
      "partNumber": "10280",
      "description": "COMBO / REFLECTOR STAND"
    },
    {
      "partNumber": "10285",
      "description": "MAX MENACE STAND"
    },
    {
      "partNumber": "10285-50",
      "description": "AIRCRAFT PIN"
    },
    {
      "partNumber": "10287",
      "description": "HAND TRUCK W/ 8 25LB WEIGHTS"
    },
    {
      "partNumber": "10290",
      "description": "MINI MAX MENACE STAND"
    },
    {
      "partNumber": "10295",
      "description": "MEGA BOOM"
    },
    {
      "partNumber": "10300",
      "description": "MOMBO STAND"
    },
    {
      "partNumber": "10321",
      "description": "MOMBO STAND WHEEL (EACH)"
    },
    {
      "partNumber": "10325",
      "description": "MOMBO STAND WHEEL OFF-ROAD EACH"
    },
    {
      "partNumber": "10340",
      "description": "TURTLE STAND"
    },
    {
      "partNumber": "10360",
      "description": "3-RISE HEAVY DUTY COMBO"
    },
    {
      "partNumber": "10380",
      "description": "3-RISE HEAVY DUTY COMBO W/4-1/2” GRIP HEAD"
    },
    {
      "partNumber": "10402",
      "description": "COMBO STAND WHEEL (EACH)"
    },
    {
      "partNumber": "10410",
      "description": "COMBO STAND WHEEL 3/4” (EACH)"
    },
    {
      "partNumber": "11420",
      "description": "20' X 30' CAMO NET"
    },
    {
      "partNumber": "11470",
      "description": "20' X 30' CHROMA KEY BLUE"
    },
    {
      "partNumber": "11475",
      "description": "20' X 30' CHROMA KEY GREEN"
    },
    {
      "partNumber": "11600",
      "description": "20' X 30' DAY BLUE"
    },
    {
      "partNumber": "11610",
      "description": "20' X 30' NITE BLUE"
    },
    {
      "partNumber": "11620",
      "description": "20' X 30' DAY GRAY"
    },
    {
      "partNumber": "11640",
      "description": "20' X 30' DIGITAL BLUE "
    },
    {
      "partNumber": "11650",
      "description": "20' X 30' DIGITAL GREEN"
    },
    {
      "partNumber": "11660",
      "description": "20' X 30' DUVATYNE"
    },
    {
      "partNumber": "11680",
      "description": "20' X 30' FULL GRID"
    },
    {
      "partNumber": "11690",
      "description": "20' X 30' 1/2 GRID"
    },
    {
      "partNumber": "11700",
      "description": "20' X 30' 1/4 GRID"
    },
    {
      "partNumber": "11705",
      "description": "20' X 30' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "11710",
      "description": "20' X 30' MAGIC CLOTH"
    },
    {
      "partNumber": "11715",
      "description": "20' X 30' MUSLIN UNBLEACHED"
    },
    {
      "partNumber": "11720",
      "description": "20' X 30' MUSLIN BLEACHED"
    },
    {
      "partNumber": "11730",
      "description": "20' X 30' POLY SILK"
    },
    {
      "partNumber": "11740",
      "description": "20' X 30' 1/4 SILK"
    },
    {
      "partNumber": "11750",
      "description": "20' X 30' ULTA BLACK"
    },
    {
      "partNumber": "11760",
      "description": "20' X 30' ULTRA BOUNCE"
    },
    {
      "partNumber": "11800",
      "description": "20' X 30' WATER BLACK"
    },
    {
      "partNumber": "11930",
      "description": "20' X 40' CAMO NET"
    },
    {
      "partNumber": "11950",
      "description": "20' X 40' CROMA KEY BLUE"
    },
    {
      "partNumber": "11955",
      "description": "20' X 40' CROMA KEY GREEN"
    },
    {
      "partNumber": "11970",
      "description": "20' X 40' DAY BLUE"
    },
    {
      "partNumber": "11980",
      "description": "20' X 40' NITE BLUE"
    },
    {
      "partNumber": "11990",
      "description": "20' X 40' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "12000",
      "description": "20' X 40' DIGITAL GREEN"
    },
    {
      "partNumber": "12020",
      "description": "20' X 40' DUVATYNE"
    },
    {
      "partNumber": "12030",
      "description": "20' X 40' FULL GRID SILENT"
    },
    {
      "partNumber": "12040",
      "description": "20' X 40' 1/2 GRID CLOTH "
    },
    {
      "partNumber": "12060",
      "description": "20' X 40' MUSLIN BLEACHED"
    },
    {
      "partNumber": "12080",
      "description": "20' X 40' POLY SILK"
    },
    {
      "partNumber": "12084",
      "description": "20' X 40' BLACK POLY SILK"
    },
    {
      "partNumber": "12086",
      "description": "20' X 40' ULTRA BLACK"
    },
    {
      "partNumber": "12090",
      "description": "20' X 40' ULTRA BOUNCE"
    },
    {
      "partNumber": "12100",
      "description": "20' X 40' WATER BLACK"
    },
    {
      "partNumber": "12105",
      "description": "20' X 50' CHROMA BLUE (POLY PRO)"
    },
    {
      "partNumber": "12130",
      "description": "20' X 50' DAY BLUE"
    },
    {
      "partNumber": "12150",
      "description": "20' X 50' DAY GRAY"
    },
    {
      "partNumber": "12175",
      "description": "20' X 50' DUVATYNE"
    },
    {
      "partNumber": "12280",
      "description": "20' X 60' DAY BLUE"
    },
    {
      "partNumber": "12290",
      "description": "20' X 60' NITE BLUE"
    },
    {
      "partNumber": "12300",
      "description": "20' X 60' DIGITAL BLUE"
    },
    {
      "partNumber": "12310",
      "description": "20' X 60' DIGITAL GREEN"
    },
    {
      "partNumber": "12340",
      "description": "20' X 60' DUVATYNE"
    },
    {
      "partNumber": "12360",
      "description": "20' X 60' 1/2 GRID SILENT"
    },
    {
      "partNumber": "12380",
      "description": "20' X 60' DAY GRAY"
    },
    {
      "partNumber": "12480",
      "description": "20' X 80' DAY BLUE"
    },
    {
      "partNumber": "12510",
      "description": "20' X 80' DIGITAL BLUE"
    },
    {
      "partNumber": "12610",
      "description": "20' X 85' DUVATYNE"
    },
    {
      "partNumber": "13000",
      "description": "30' X 30' CROMA KEY GREEN "
    },
    {
      "partNumber": "13020",
      "description": "30' X 30' DAY BLUE"
    },
    {
      "partNumber": "13040",
      "description": "30' X 30' DIGITAL GREEN"
    },
    {
      "partNumber": "13060",
      "description": "30' X 30' DUVATYNE"
    },
    {
      "partNumber": "13063",
      "description": "30' X 30' 1/2 SOFT FROST"
    },
    {
      "partNumber": "13065",
      "description": "30' X 30' FULL GRID NOISY"
    },
    {
      "partNumber": "13070",
      "description": "30' X 30' FULL SILENT GRID"
    },
    {
      "partNumber": "13080",
      "description": "30' X 30' 1/2 GRID"
    },
    {
      "partNumber": "13090",
      "description": "30' X 30' 1/4 SILENT GRID"
    },
    {
      "partNumber": "13110",
      "description": "30' X 30'  MUSLIN BLEACHED"
    },
    {
      "partNumber": "13130",
      "description": "30' X 30' POLY SILK"
    },
    {
      "partNumber": "13140",
      "description": "30' X 30' 1/4 SILK"
    },
    {
      "partNumber": "13150",
      "description": "30' X 30' 1/4 BLACK SILK"
    },
    {
      "partNumber": "13180",
      "description": "30' X 30' ULTRA BLACK"
    },
    {
      "partNumber": "13310",
      "description": "30' X 40' DAY BLUE"
    },
    {
      "partNumber": "13330",
      "description": "30' X 40' DAY GRAY"
    },
    {
      "partNumber": "13340",
      "description": "30' X 40' CHROMA GREEN (POLY PRO)"
    },
    {
      "partNumber": "13350",
      "description": "30' X 40' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "13360",
      "description": "30' X 40' DIGITAL GREEN "
    },
    {
      "partNumber": "13380",
      "description": "30' X 40' DUVATYNE"
    },
    {
      "partNumber": "13400",
      "description": "30' X 40' FULL SILENT GRID W/ PICKUPS"
    },
    {
      "partNumber": "13420",
      "description": "30' X 40' 1/2 GRID CLOTH"
    },
    {
      "partNumber": "13440",
      "description": "30' X 40' POLY SILK"
    },
    {
      "partNumber": "13445",
      "description": "30' X 40' 1/2 SILK"
    },
    {
      "partNumber": "13490",
      "description": "30' X 40' ULTRA BLACK"
    },
    {
      "partNumber": "13590",
      "description": "30' X 50' CHROMA BLUE (POLY PRO)"
    },
    {
      "partNumber": "13600",
      "description": "30' X 50' CHROMA GREEN (TEMPO)"
    },
    {
      "partNumber": "13605",
      "description": "30' X 50' DAY BLUE"
    },
    {
      "partNumber": "13610",
      "description": "30' X 50' DIGITAL GREEN"
    },
    {
      "partNumber": "13615",
      "description": "30' X 50' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "13630",
      "description": "30' X 50' DUVATYNE"
    },
    {
      "partNumber": "13670",
      "description": "30' X 50' 1/2 SILENT GRID W/ PICK UPS"
    },
    {
      "partNumber": "13765",
      "description": "30' X 60' CHROMA GREEN (POLY PRO)"
    },
    {
      "partNumber": "13770",
      "description": "30' X 60' DUVATYNE"
    },
    {
      "partNumber": "13780",
      "description": "30' X 60' DIGITAL BLUE "
    },
    {
      "partNumber": "13790",
      "description": "30' X 60' BLEACHED MUSLIN"
    },
    {
      "partNumber": "13820",
      "description": "30' X 80' DAY BLUE"
    },
    {
      "partNumber": "13860",
      "description": "30' X 80' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "13890",
      "description": "30' X 80' DIGITAL GREEN"
    },
    {
      "partNumber": "13960",
      "description": "30' X 80' DUVATYNE"
    },
    {
      "partNumber": "13980",
      "description": "30' X 80' ULTRABOUNCE"
    },
    {
      "partNumber": "14010",
      "description": "30' X 90' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "14030",
      "description": "30' X 100' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "14060",
      "description": "30' X 120 DIGITAL GREEN (TEMPO)"
    },
    {
      "partNumber": "16000",
      "description": "40' X 40' DUVATYNE"
    },
    {
      "partNumber": "16530",
      "description": "40' X 40' FULL GRID CLOTH"
    },
    {
      "partNumber": "16550",
      "description": "40' X 40' 1/2 GRID CLOTH"
    },
    {
      "partNumber": "16600",
      "description": "40' X 40' POLY SILK"
    },
    {
      "partNumber": "20000",
      "description": "40' X 60' 1/2 SILENT GRID W/ PICKUPS"
    },
    {
      "partNumber": "21550",
      "description": "40' X 100' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "21555",
      "description": "40' X 100' DIGITAL GREEN (TEMPO)"
    },
    {
      "partNumber": "22500",
      "description": "40' X 120' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "23000",
      "description": "60' X 80' 1/2 GRID W/PICK-UPS"
    },
    {
      "partNumber": "24030",
      "description": "20' X 20' FRAME"
    },
    {
      "partNumber": "24061",
      "description": "20' X 20' EAR (1 EACH)"
    },
    {
      "partNumber": "24065",
      "description": "20' X 20' OFFSET EAR (1 EACH)"
    },
    {
      "partNumber": "24071",
      "description": "20' X 20' CORNER (1 EACH)"
    },
    {
      "partNumber": "24120",
      "description": "20' X 20' SINGLE"
    },
    {
      "partNumber": "24150",
      "description": "20' X 20' DOUBLE"
    },
    {
      "partNumber": "24180",
      "description": "20' X 20' SOLID"
    },
    {
      "partNumber": "24210",
      "description": "20' X 20' POLY SILK"
    },
    {
      "partNumber": "24215",
      "description": "20' X 20' POLY SILK BOOTIES"
    },
    {
      "partNumber": "24220",
      "description": "20' X 20' 1/4 BLACK SILK"
    },
    {
      "partNumber": "24240",
      "description": "20' X 20' CHINA SILK"
    },
    {
      "partNumber": "24250",
      "description": "20' X 20' CHINA SILK BLACK"
    },
    {
      "partNumber": "24270",
      "description": "20' X 20' 1/4 SILK"
    },
    {
      "partNumber": "24300",
      "description": "20' X 20' DAY BLUE"
    },
    {
      "partNumber": "24310",
      "description": "20' X 20' NIGHT BLUE"
    },
    {
      "partNumber": "24330",
      "description": "20' X 20' CAMO NET"
    },
    {
      "partNumber": "24355",
      "description": "20' X 20' CHECKBOARD GOLD / WHITE"
    },
    {
      "partNumber": "24360",
      "description": "20' X 20' CHECKERBOARD SILVER / GOLD "
    },
    {
      "partNumber": "24365",
      "description": "20' X 20' CHECKERBOARD SILVER / WHITE"
    },
    {
      "partNumber": "24380",
      "description": "20' X 20' CROMA KEY BLUE"
    },
    {
      "partNumber": "24384",
      "description": "20' X 20' CHROMA BLUE (TEMPO) BOOTIES"
    },
    {
      "partNumber": "24390",
      "description": "20' X 20' CHROMA KEY GREEN "
    },
    {
      "partNumber": "24395",
      "description": "20' X 20' CHROMA GREEN (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "24400",
      "description": "20' X 20' CHROMA GREEN (TEMPO) BOOTIES"
    },
    {
      "partNumber": "24420",
      "description": "20' X 20' DIGITAL BLUE "
    },
    {
      "partNumber": "24425",
      "description": "20' X 20' DIGITAL BLUE (TEMPO) BOOTIES"
    },
    {
      "partNumber": "24450",
      "description": "20' X 20' DIGITAL GREEN "
    },
    {
      "partNumber": "24470",
      "description": "20' X 20' DIGITAL GREEN (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "24480",
      "description": "20' X 20' SOFT FROST"
    },
    {
      "partNumber": "24510",
      "description": "20' X 20' 1/2 SOFT FROST"
    },
    {
      "partNumber": "24525",
      "description": "20' X 20' GRAY DAY"
    },
    {
      "partNumber": "24530",
      "description": "20' X 20' GRAY NITE"
    },
    {
      "partNumber": "24532",
      "description": "20' X 20' GRAY 1/2 GRID 7%"
    },
    {
      "partNumber": "24535",
      "description": "20' X 20' GRID CLOTH BLACK"
    },
    {
      "partNumber": "24537",
      "description": "20' X 20' BLACK FULL GRID BOOTIES"
    },
    {
      "partNumber": "24540",
      "description": "20' X 20' FULL GRID"
    },
    {
      "partNumber": "24545",
      "description": "20' X 20' FULL GRID FRAME BOOTIES"
    },
    {
      "partNumber": "24570",
      "description": "20' X 20' 1/2 GRID"
    },
    {
      "partNumber": "24580",
      "description": "20' X 20' 1/2 GRID FRAME BOOT"
    },
    {
      "partNumber": "24600",
      "description": "20' X 20' 1/4 GRID"
    },
    {
      "partNumber": "24630",
      "description": "20' X 20' FULL SILENT GRID"
    },
    {
      "partNumber": "24660",
      "description": "20' X 20' 1/2 SILENT GRID"
    },
    {
      "partNumber": "24690",
      "description": "20' X 20' 1/4 SILENT GRID"
    },
    {
      "partNumber": "24720",
      "description": "20' X 20' GRIFFOLYN B/W"
    },
    {
      "partNumber": "24730",
      "description": "20' X 20' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "24750",
      "description": "20' X 20' GRIFFOLYN W/W"
    },
    {
      "partNumber": "24780",
      "description": "20' X 20' HI LITE"
    },
    {
      "partNumber": "24810",
      "description": "20' X 20' LAMAY SILVER "
    },
    {
      "partNumber": "24840",
      "description": "20' X 20' LAMAY GOLD "
    },
    {
      "partNumber": "24845",
      "description": "20' X 20' LEAF-O-LORIS"
    },
    {
      "partNumber": "24860",
      "description": "20' X 20' MAGIC CLOTH"
    },
    {
      "partNumber": "24870",
      "description": "20' X 20' MUSLIN UNBLEACHED "
    },
    {
      "partNumber": "24874",
      "description": "20' X 20' ROPE OF LEAVES"
    },
    {
      "partNumber": "24900",
      "description": "20' X 20' MUSLIN BLEACHED "
    },
    {
      "partNumber": "24910",
      "description": "20' X 20' MUSLIN BLEACHED SEAMLESS"
    },
    {
      "partNumber": "24930",
      "description": "20' X 20' SILK BLACK"
    },
    {
      "partNumber": "24935",
      "description": "20' X 20' SOFT EGG CRATE 50 DEGREE"
    },
    {
      "partNumber": "24950",
      "description": "20' X 20' ULTRA BLACK"
    },
    {
      "partNumber": "24960",
      "description": "20' X 20' ULTRA BOUNCE"
    },
    {
      "partNumber": "24961",
      "description": "20' X 20' ULTRA BOUNCE FRAME BOOT"
    },
    {
      "partNumber": "24963",
      "description": "20' X 20' VELVET BLACK"
    },
    {
      "partNumber": "24965",
      "description": "20' X 20' WATER BLACK"
    },
    {
      "partNumber": "24967",
      "description": "20' X 20' WHITE BLACKOUT"
    },
    {
      "partNumber": "24990",
      "description": "20' X 20' WHITE DUVATYNE"
    },
    {
      "partNumber": "24995",
      "description": "20' X 20' WHITE NET"
    },
    {
      "partNumber": "26060",
      "description": "12' X 20' FRAME"
    },
    {
      "partNumber": "26120",
      "description": "12' X 20' SINGLE"
    },
    {
      "partNumber": "26150",
      "description": "12' X 20' DOUBLE"
    },
    {
      "partNumber": "26180",
      "description": "12' X 20' SOLID"
    },
    {
      "partNumber": "26210",
      "description": "12' X 20' POLY SILK"
    },
    {
      "partNumber": "26215",
      "description": "12' X 20' BLACK CHINA SILK"
    },
    {
      "partNumber": "26220",
      "description": "12' X 20' 1/4 BLACK SILK"
    },
    {
      "partNumber": "26240",
      "description": "12' X 20' CHINA SILK"
    },
    {
      "partNumber": "26270",
      "description": "12' X 20' 1/4 SILK"
    },
    {
      "partNumber": "26300",
      "description": "12' X 20' DAY BLUE "
    },
    {
      "partNumber": "26310",
      "description": "12' X 20' NIGHT BLUE"
    },
    {
      "partNumber": "26330",
      "description": "12' X 20' CAMO NET"
    },
    {
      "partNumber": "26350",
      "description": "12' X 20' CHECKBOARD GOLD / WHITE"
    },
    {
      "partNumber": "26360",
      "description": "12' X 20' CHECKERBOARD SILVER / GOLD "
    },
    {
      "partNumber": "26365",
      "description": "12' X 20' CHECKERBOARD SILVER / WHITE"
    },
    {
      "partNumber": "26380",
      "description": "12' X 20' CHROMA KEY BLUE"
    },
    {
      "partNumber": "26384",
      "description": "12' X 20' CHROMA BLUE (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "26390",
      "description": "12' X 20' CHROMA KEY GREEN "
    },
    {
      "partNumber": "26394",
      "description": "12' X 20' CHROMA GREEN (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "26398",
      "description": "12' X 20' CHROMA GREEN (TEMPO) BOOTIES"
    },
    {
      "partNumber": "26420",
      "description": "12' X 20' DIGITAL BLUE "
    },
    {
      "partNumber": "26424",
      "description": "12' X 20' DIGITAL BLUE (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "26428",
      "description": "12' X 20' DIGITAL BLUE (TEMPO) BOOTIES"
    },
    {
      "partNumber": "26450",
      "description": "12' X 20' DIGITAL GREEN "
    },
    {
      "partNumber": "26454",
      "description": "12' X 20' DIGITAL GREEN (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "26458",
      "description": "12' X 20' DIGITAL GREEN (TEMPO) BOOTIES"
    },
    {
      "partNumber": "26480",
      "description": "12' X 20' SOFT FROST"
    },
    {
      "partNumber": "26510",
      "description": "12' X 20' 1/2 SOFT FROST"
    },
    {
      "partNumber": "26525",
      "description": "12' X 20' GRAY DAY"
    },
    {
      "partNumber": "26530",
      "description": "12' X 20' GRAY NITE"
    },
    {
      "partNumber": "26532",
      "description": "12' X 20' GRAY 1/2 GRID 7%"
    },
    {
      "partNumber": "26535",
      "description": "12' X 20' GRID CLOTH BLACK"
    },
    {
      "partNumber": "26540",
      "description": "12' X 20' FULL GRID"
    },
    {
      "partNumber": "26545",
      "description": "12' X 20' FULL GRID BOOTIES"
    },
    {
      "partNumber": "26570",
      "description": "12' X 20' 1/2 GRID"
    },
    {
      "partNumber": "26590",
      "description": "12' X 20' 1/2 GRID BOOTIES"
    },
    {
      "partNumber": "26600",
      "description": "12' X 20' 1/4 GRID"
    },
    {
      "partNumber": "26630",
      "description": "12' X 20' FULL SILENT GRID"
    },
    {
      "partNumber": "26660",
      "description": "12' X 20' 1/2 SILENT GRID"
    },
    {
      "partNumber": "26690",
      "description": "12' X 20' 1/4 SILENT GRID"
    },
    {
      "partNumber": "26720",
      "description": "12' X 20' GRIFFOLYN B/W"
    },
    {
      "partNumber": "26750",
      "description": "12' X 20' GRIFFOLYN W/W"
    },
    {
      "partNumber": "26760",
      "description": "12' X 20' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "26780",
      "description": "12' X 20' HI LITE"
    },
    {
      "partNumber": "26810",
      "description": "12' X 20' LAMAY SILVER "
    },
    {
      "partNumber": "26840",
      "description": "12' X 20' LAMAY GOLD "
    },
    {
      "partNumber": "26850",
      "description": "12' X 20' MAGIC CLOTH"
    },
    {
      "partNumber": "26870",
      "description": "12' X 20' MUSLIN UNBLEACHED "
    },
    {
      "partNumber": "26900",
      "description": "12' X 20' MUSLIN BLEACHED "
    },
    {
      "partNumber": "26905",
      "description": "12' X 20' MUSLIN BLEACHED SEAMLESS"
    },
    {
      "partNumber": "26930",
      "description": "12' X 20' BLACK SILK"
    },
    {
      "partNumber": "26934",
      "description": "12' X 20' SOFT EGG CRATE 50 DEGREE"
    },
    {
      "partNumber": "26938",
      "description": "12' X 20' TEASER"
    },
    {
      "partNumber": "26940",
      "description": "12' X 20' ULTRA BLACK"
    },
    {
      "partNumber": "26955",
      "description": "12' X 20' ULTRA BOUNCE"
    },
    {
      "partNumber": "26957",
      "description": "12' X 20' ULTRA BOUNCE BOOTIES"
    },
    {
      "partNumber": "26960",
      "description": "12' X 20' BLACK VELVET"
    },
    {
      "partNumber": "26962",
      "description": "12' X 20' WHITE BLACKOUT"
    },
    {
      "partNumber": "26965",
      "description": "12' X 20' WATER BLACK"
    },
    {
      "partNumber": "26990",
      "description": "12' X 20' WHITE DUVATYNE"
    },
    {
      "partNumber": "26995",
      "description": "12' X 20' WHITE NET"
    },
    {
      "partNumber": "27120",
      "description": "10' X 20' SINGLE"
    },
    {
      "partNumber": "27150",
      "description": "10' X 20' DOUBLE"
    },
    {
      "partNumber": "27180",
      "description": "10' X 20' SOLID"
    },
    {
      "partNumber": "27210",
      "description": "10' X 20' POLY SILK"
    },
    {
      "partNumber": "27240",
      "description": "10' X 20' CHINA SILK"
    },
    {
      "partNumber": "27270",
      "description": "10' X 20' 1/4 SILK"
    },
    {
      "partNumber": "27300",
      "description": "10' X 20' DAY BLUE"
    },
    {
      "partNumber": "27310",
      "description": "10' X 20' NIGHT BLUE"
    },
    {
      "partNumber": "27330",
      "description": "10' X 20' CAMO NET"
    },
    {
      "partNumber": "27380",
      "description": "10' X 20' CHROMA KEY BLUE"
    },
    {
      "partNumber": "27390",
      "description": "10' X 20' CHROMA KEY GREEN"
    },
    {
      "partNumber": "27420",
      "description": "10' X 20' DIGITAL BLUE"
    },
    {
      "partNumber": "27450",
      "description": "10' X 20' DIGITAL GREEN"
    },
    {
      "partNumber": "27480",
      "description": "10' X 20' SOFT FROST"
    },
    {
      "partNumber": "27510",
      "description": "10' X 20' 1/2 SOFT FROST"
    },
    {
      "partNumber": "27525",
      "description": "10' X 20' GRAY DAY"
    },
    {
      "partNumber": "27540",
      "description": "10' X 20' FULL GRID SILENT"
    },
    {
      "partNumber": "27570",
      "description": "10' X 20' 1/2 GRID SILENT"
    },
    {
      "partNumber": "27600",
      "description": "10' X 20' 1/4 GRID SILENT"
    },
    {
      "partNumber": "27720",
      "description": "10' X 20' GRIFFOLYN B/W"
    },
    {
      "partNumber": "27780",
      "description": "10' X 20' HI LITE "
    },
    {
      "partNumber": "27870",
      "description": "10' X 20' MUSLIN BLEACHED"
    },
    {
      "partNumber": "27900",
      "description": "10' X 20' MUSLIN UNBLEACHED"
    },
    {
      "partNumber": "27940",
      "description": "10' X 20' SILVER LAME"
    },
    {
      "partNumber": "27960",
      "description": "10' X 20' ULTRA BOUNCE"
    },
    {
      "partNumber": "28060",
      "description": "12' X 12' FRAME"
    },
    {
      "partNumber": "28065",
      "description": "12' X 12' 1” SQUARE STOCK"
    },
    {
      "partNumber": "28090",
      "description": "12 X FRAME SLIDING EARS (1 EACH)"
    },
    {
      "partNumber": "28120",
      "description": "12 X MODERN KWIK CHANGE EARS/1” SQ TUBE (EA)"
    },
    {
      "partNumber": "28130",
      "description": "12X REVERSIBLE EARS (SET OF 2)"
    },
    {
      "partNumber": "28135",
      "description": "12' X 12' CORNER BRACE, SQUARE STOCK"
    },
    {
      "partNumber": "28150",
      "description": "12' X 12' SINGLE"
    },
    {
      "partNumber": "28180",
      "description": "12' X 12' DOUBLE"
    },
    {
      "partNumber": "28210",
      "description": "12' X 12' SOLID"
    },
    {
      "partNumber": "28240",
      "description": "12' X 12' POLY SILK"
    },
    {
      "partNumber": "28250",
      "description": "12' X 12' POLY SILK BLACK"
    },
    {
      "partNumber": "28270",
      "description": "12' X 12' CHINA SILK"
    },
    {
      "partNumber": "28275",
      "description": "12' X 12' BLACK CHINA SILK"
    },
    {
      "partNumber": "28300",
      "description": "12' X 12' 1/4 SILK"
    },
    {
      "partNumber": "28330",
      "description": "12' X 12' DAY BLUE"
    },
    {
      "partNumber": "28340",
      "description": "12' X 12' NIGHT BLUE"
    },
    {
      "partNumber": "28360",
      "description": "12' X 12' CAMO NET"
    },
    {
      "partNumber": "28385",
      "description": "12' X 12' CHECKERBOARD GOLD / WHITE"
    },
    {
      "partNumber": "28390",
      "description": "12' X 12' CHECKERBOARD SILVER / GOLD "
    },
    {
      "partNumber": "28391",
      "description": "12' X 12' CHECKERBOARD WHITE / SILVER"
    },
    {
      "partNumber": "28410",
      "description": "12' X 12' CHROMA KEY BLUE"
    },
    {
      "partNumber": "28414",
      "description": "12' X 12' CHROMA BLUE (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "28418",
      "description": "12' X 12' CHROMA BLUE (TEMPO) BOOTIES"
    },
    {
      "partNumber": "28420",
      "description": "12' X 12'' CHROMA KEY GREEN "
    },
    {
      "partNumber": "28424",
      "description": "12' X 12' CHROMA GREEN (POLY PRO) BOOTIES"
    },
    {
      "partNumber": "28428",
      "description": "12' X 12' CHROMA GREEN (TEMPO) BOOTIES"
    },
    {
      "partNumber": "28450",
      "description": "12' X 12' DIGITAL BLUE "
    },
    {
      "partNumber": "28454",
      "description": "12' X 12' DIGITAL BLUE (TEMPO) BOOTIES"
    },
    {
      "partNumber": "28480",
      "description": "12' X 12' DIGITAL GREEN "
    },
    {
      "partNumber": "28490",
      "description": "12' X 12' DIGITAL GREEN BOOTIES"
    },
    {
      "partNumber": "28510",
      "description": "12' X 12' SOFT FROST"
    },
    {
      "partNumber": "28540",
      "description": "12' X 12' 1/2 SOFT FROST"
    },
    {
      "partNumber": "28555",
      "description": "12' X 12' GRAY DAY"
    },
    {
      "partNumber": "28557",
      "description": "12' X 12' GRAY 1/2 GRID 7%"
    },
    {
      "partNumber": "28560",
      "description": "12' X 12' BLACK GRID"
    },
    {
      "partNumber": "28570",
      "description": "12' X 12' FULL GRID"
    },
    {
      "partNumber": "28574",
      "description": "12' X 12' FULL GRID BOOTIES"
    },
    {
      "partNumber": "28600",
      "description": "12' X 12' 1/2 GRID"
    },
    {
      "partNumber": "28620",
      "description": "12' X 12' 1/2 GRID BOOTIES"
    },
    {
      "partNumber": "28630",
      "description": "12' X 12' 1/4 GRID"
    },
    {
      "partNumber": "28660",
      "description": "12' X 12' FULL SILENT GRID"
    },
    {
      "partNumber": "28690",
      "description": "12' X 12' 1/2 SILENT GRID"
    },
    {
      "partNumber": "28720",
      "description": "12' X 12' 1/4 SILENT GRID"
    },
    {
      "partNumber": "28740",
      "description": "12' X 12' GRAY NITE"
    },
    {
      "partNumber": "28750",
      "description": "12' X 12' GRIFFOLYN B/W"
    },
    {
      "partNumber": "28765",
      "description": "12' X 12' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "28780",
      "description": "12' X 12' GRIFFOLYN W/W"
    },
    {
      "partNumber": "28810",
      "description": "12' X 12' HI LITE"
    },
    {
      "partNumber": "28840",
      "description": "12' X 12' LAMAY SILVER "
    },
    {
      "partNumber": "28870",
      "description": "12' X 12' LAMAY GOLD "
    },
    {
      "partNumber": "28880",
      "description": "12' X 12' LEAF-O-LORIS"
    },
    {
      "partNumber": "28884-",
      "description": "12' X 12' ROPE OF LEAVES"
    },
    {
      "partNumber": "28890",
      "description": "12' X 12' MAGIC CLOTH"
    },
    {
      "partNumber": "28900",
      "description": "12' X 12' MICROWAVE SILVER"
    },
    {
      "partNumber": "28930",
      "description": "12' X 12' MUSLIN BLEACHED "
    },
    {
      "partNumber": "28945",
      "description": "12' X 12' MUSLIN BLACK"
    },
    {
      "partNumber": "28950",
      "description": "12' X 12' MUSLIN BLEACHED SEAMLESS"
    },
    {
      "partNumber": "28960",
      "description": "12' X 12' MUSLIN UNBLEACHED "
    },
    {
      "partNumber": "28990",
      "description": "12' X 12' SILK BLACK"
    },
    {
      "partNumber": "29000",
      "description": "12' X 12' 1/4 BLACK SILK"
    },
    {
      "partNumber": "29010",
      "description": "12' X 12' SHARKSTOOTH BLACK"
    },
    {
      "partNumber": "29020",
      "description": "12' X 12' SOFT EGG CRATES 50 DEGREE"
    },
    {
      "partNumber": "29045",
      "description": "12' X 12' ULTRA BLACK"
    },
    {
      "partNumber": "29050",
      "description": "12' X 12' ULTRA BOUNCE"
    },
    {
      "partNumber": "29052-",
      "description": "12' X 12' ULTRA BOUNCE FRAME BOOTIES"
    },
    {
      "partNumber": "29055",
      "description": "12' X 12' WATER BLACK"
    },
    {
      "partNumber": "29057",
      "description": "12' X 12' WHITE BLACKOUT"
    },
    {
      "partNumber": "29058",
      "description": "12' X 12' WHITE NET"
    },
    {
      "partNumber": "29060",
      "description": "12' X 12' VELVET BLACK"
    },
    {
      "partNumber": "29080",
      "description": "12' X 12' WHITE DUVATYNE"
    },
    {
      "partNumber": "30060",
      "description": "8' X 8'  FRAME"
    },
    {
      "partNumber": "30065",
      "description": "8' X 8' SQUARE STOCK"
    },
    {
      "partNumber": "30090",
      "description": "8' X 8' SINGLE"
    },
    {
      "partNumber": "30120",
      "description": "8' X 8' DOUBLE"
    },
    {
      "partNumber": "30150",
      "description": "8' X 8' SOLID"
    },
    {
      "partNumber": "30180",
      "description": "8' X 8' POLY SILK"
    },
    {
      "partNumber": "30190",
      "description": "8' X 8' BLACK POLY SILK"
    },
    {
      "partNumber": "30195",
      "description": "8' X 8' 1/4 BLACK SILK"
    },
    {
      "partNumber": "30210",
      "description": "8' X 8' CHINA SILK"
    },
    {
      "partNumber": "30220",
      "description": "8' X 8' CHINA SILK BLACK"
    },
    {
      "partNumber": "30240",
      "description": "8' X 8' 1/4 SILK"
    },
    {
      "partNumber": "30270",
      "description": "8' X 8'  DAY BLUE"
    },
    {
      "partNumber": "30280",
      "description": "8' X 8'  NITE BLUE"
    },
    {
      "partNumber": "30300",
      "description": "8' X 8' CAMO NET"
    },
    {
      "partNumber": "30325",
      "description": "8' X 8' CHECKERBOARD GOLD / WHITE"
    },
    {
      "partNumber": "30330",
      "description": "8' X 8' CHECKERBOARD SILVER / GOLD "
    },
    {
      "partNumber": "30335",
      "description": "8' X 8' CHECKERBOARD SILVER / WHITE"
    },
    {
      "partNumber": "30350",
      "description": "8' X 8' CHROMA KEY BLUE"
    },
    {
      "partNumber": "30360",
      "description": "8' X 8' CHROMA KEY GREEN "
    },
    {
      "partNumber": "30390",
      "description": "8' X 8'' DIGITAL BLUE "
    },
    {
      "partNumber": "30420",
      "description": "8' X 8' DIGITAL GREEN "
    },
    {
      "partNumber": "30450",
      "description": "8' X 8' SOFT FROST"
    },
    {
      "partNumber": "30480",
      "description": "8' X 8' 1/2 SOFT FROST"
    },
    {
      "partNumber": "30500",
      "description": "8' X 8' GRID CLOTH BLACK"
    },
    {
      "partNumber": "30510",
      "description": "8' X 8' FULL GRID"
    },
    {
      "partNumber": "30540",
      "description": "8' X 8' 1/2 GRID"
    },
    {
      "partNumber": "30560",
      "description": "8' X 8' 1/2 GRID BOOTIES"
    },
    {
      "partNumber": "30570",
      "description": "8' X 8' 1/4 GRID"
    },
    {
      "partNumber": "30600",
      "description": "8' X 8' FULL SILENT GRID"
    },
    {
      "partNumber": "30630",
      "description": "8' X 8' 1/2 SILENT GRID"
    },
    {
      "partNumber": "30660",
      "description": "8' X 8' 1/4 SILENT GRID"
    },
    {
      "partNumber": "30670",
      "description": "8' X 8' GRAY DAY"
    },
    {
      "partNumber": "30672",
      "description": "8' X 8' GRAY 1/2 GRID 7%"
    },
    {
      "partNumber": "30675",
      "description": "8' X 8' GRAY NITE"
    },
    {
      "partNumber": "30690",
      "description": "8' X 8' GRIFFOLYN B/W"
    },
    {
      "partNumber": "30700",
      "description": "8' X 8' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "30720",
      "description": "8' X 8' GRIFFOLYN W/W"
    },
    {
      "partNumber": "30750",
      "description": "8' X 8' HI LITE"
    },
    {
      "partNumber": "30780",
      "description": "8' X 8' LAMAY SILVER "
    },
    {
      "partNumber": "30810",
      "description": "8' X 8' LAMAY GOLD "
    },
    {
      "partNumber": "30820",
      "description": "8' X 8' MAGIC CLOTH"
    },
    {
      "partNumber": "30840",
      "description": "8' X 8' MICROWAVE SILVER"
    },
    {
      "partNumber": "30870",
      "description": "8' X 8' MUSLIN UNBLEACHED "
    },
    {
      "partNumber": "30900",
      "description": "8' X 8' MUSLIN BLEACHED "
    },
    {
      "partNumber": "30930",
      "description": "8' X 8' SILK BLACK"
    },
    {
      "partNumber": "30960",
      "description": "8' X 8' SOFT EGG CRATES 50 DEGREE"
    },
    {
      "partNumber": "30975",
      "description": "8' X 8' ULTRA BLACK"
    },
    {
      "partNumber": "30990",
      "description": "8' X 8' ULTRA BOUNCE"
    },
    {
      "partNumber": "30995",
      "description": "8' X 8' BLACK VELVET"
    },
    {
      "partNumber": "31010",
      "description": "8' X 8' WAG FLAG"
    },
    {
      "partNumber": "31015",
      "description": "8' X 8' WATER SOLID"
    },
    {
      "partNumber": "31020",
      "description": "8' X 8' WHITE DUVATYNE"
    },
    {
      "partNumber": "31040",
      "description": "8' X 8' WHITE NET"
    },
    {
      "partNumber": "31050",
      "description": "8' X 8' WHITE OUT"
    },
    {
      "partNumber": "31055",
      "description": "8' X 8' PAPER BLIND EFFECT"
    },
    {
      "partNumber": "32060",
      "description": "6' X 6' FRAME"
    },
    {
      "partNumber": "32090",
      "description": "6' X 6' SINGLE"
    },
    {
      "partNumber": "32120",
      "description": "6' X 6' DOUBLE"
    },
    {
      "partNumber": "32150",
      "description": "6' X 6' SOLID"
    },
    {
      "partNumber": "32180",
      "description": "6' X 6' POLY SILK"
    },
    {
      "partNumber": "32195",
      "description": "6' X 6' BLACK CHINA SILK"
    },
    {
      "partNumber": "32200",
      "description": "6' X 6' 1/4 BLACK SILK"
    },
    {
      "partNumber": "32210",
      "description": "6' X 6' CHINA SILK"
    },
    {
      "partNumber": "32240",
      "description": "6' X 6' 1/4 SILK"
    },
    {
      "partNumber": "32270",
      "description": "6' X 6' DAY BLUE"
    },
    {
      "partNumber": "32280",
      "description": "6' X 6' NITE BLUE"
    },
    {
      "partNumber": "32300",
      "description": "6' X 6' CAMO NET"
    },
    {
      "partNumber": "32330",
      "description": "6' X 6' CHECKERBOARD SILVER / GOLD "
    },
    {
      "partNumber": "32335",
      "description": "6' X 6' CHECKERBOARD SILVER / WHITE"
    },
    {
      "partNumber": "32350",
      "description": "6' X 6' CHROMA KEY BLUE"
    },
    {
      "partNumber": "32360",
      "description": "6' X 6' CHROMA KEY GREEN "
    },
    {
      "partNumber": "32390",
      "description": "6' X 6' DIGITAL BLUE "
    },
    {
      "partNumber": "32420",
      "description": "6' X 6' DIGITAL GREEN "
    },
    {
      "partNumber": "32450",
      "description": "6' X 6' SOFT FROST"
    },
    {
      "partNumber": "32480",
      "description": "6' X 6' 1/2 SOFT FROST"
    },
    {
      "partNumber": "32500",
      "description": "6' X 6' GRID CLOTH BLACK"
    },
    {
      "partNumber": "32510",
      "description": "6' X 6' FULL GRID"
    },
    {
      "partNumber": "32540",
      "description": "6' X 6' 1/2 GRID"
    },
    {
      "partNumber": "32570",
      "description": "6' X 6' 1/4 GRID"
    },
    {
      "partNumber": "32600",
      "description": "6' X 6' FULL SILENT GRID"
    },
    {
      "partNumber": "32630",
      "description": "6' X 6' 1/2 SILENT GRID"
    },
    {
      "partNumber": "32660",
      "description": "6' X 6' 1/4 SILENT GRID"
    },
    {
      "partNumber": "32665",
      "description": "6' X 6' DAY GRAY"
    },
    {
      "partNumber": "32670",
      "description": "6' X 6' GRAY NITE"
    },
    {
      "partNumber": "32690",
      "description": "6' X 6' GRIFFOLYN B/W"
    },
    {
      "partNumber": "32700",
      "description": "6' X 6' GRIFFOLYN CLEAR"
    },
    {
      "partNumber": "32720",
      "description": "6' X 6' GRIFFOLYN W/W"
    },
    {
      "partNumber": "32750",
      "description": "6' X 6' HI LITE"
    },
    {
      "partNumber": "32780",
      "description": "6' X 6' LAMAY SILVER "
    },
    {
      "partNumber": "32810",
      "description": "6' X 6' LAMAY GOLD "
    },
    {
      "partNumber": "32820",
      "description": "6' X 6' MAGIC CLOTH"
    },
    {
      "partNumber": "32840",
      "description": "6' X 6' MICROWAVE SILVER"
    },
    {
      "partNumber": "32870",
      "description": "6' X 6' MUSLIN UNBLEACHED "
    },
    {
      "partNumber": "32900",
      "description": "6' X 6' MUSLIN BLEACHED "
    },
    {
      "partNumber": "32930",
      "description": "6' X 6' SILK BLACK"
    },
    {
      "partNumber": "32960",
      "description": "6' X 6' SOFT EGG CRATES 50 DEGREE"
    },
    {
      "partNumber": "32965",
      "description": "6 X 6 WAG FLAG"
    },
    {
      "partNumber": "32990",
      "description": "6' X 6' ULTRA BOUNCE"
    },
    {
      "partNumber": "33005",
      "description": "6' X 6' BLACK VELVET"
    },
    {
      "partNumber": "33020",
      "description": "6 X 6' WHITE DUVATYNE"
    },
    {
      "partNumber": "33050",
      "description": "6' X 6' WHITE OUT"
    },
    {
      "partNumber": "33060",
      "description": "6' X 6' WHITE SINGLE"
    },
    {
      "partNumber": "34030",
      "description": "10” X 42” SOLID"
    },
    {
      "partNumber": "34035",
      "description": "10” X 42” FLOP DOWN"
    },
    {
      "partNumber": "34060",
      "description": "18” X 48” SOLID"
    },
    {
      "partNumber": "34065",
      "description": "18” X 48” FLOP DOWN"
    },
    {
      "partNumber": "34080",
      "description": "24” X 48” REFRASIL"
    },
    {
      "partNumber": "34085",
      "description": "24” X 48” OPEN END FRAME"
    },
    {
      "partNumber": "34090",
      "description": "24” X 48” SOLID"
    },
    {
      "partNumber": "34095",
      "description": "24” X 48” FLOP DOWN"
    },
    {
      "partNumber": "34120",
      "description": "24” X 60” SOLID"
    },
    {
      "partNumber": "34130",
      "description": "24” X 60” FLOP DOWN"
    },
    {
      "partNumber": "34150",
      "description": "24” X 72” SOLID"
    },
    {
      "partNumber": "34180",
      "description": "24” X 72” FLOP DOWN"
    },
    {
      "partNumber": "34185",
      "description": "24” X 72” REFRASIL"
    },
    {
      "partNumber": "34210",
      "description": "24” X 48” T FLAG"
    },
    {
      "partNumber": "34240",
      "description": "24” X 60” T FLAG"
    },
    {
      "partNumber": "34270",
      "description": "24” X 72” METAL FLAGS"
    },
    {
      "partNumber": "34300",
      "description": "4' X 8' SOFT EGG CRATE 50 DEGREE"
    },
    {
      "partNumber": "35030",
      "description": "4' X 4' BLACK"
    },
    {
      "partNumber": "35060",
      "description": "4' X 4' FLOP DOWN"
    },
    {
      "partNumber": "35065",
      "description": "4' X 4' WATER BLACK (FLOPPY)"
    },
    {
      "partNumber": "35090",
      "description": "4' X 4' SINGLE"
    },
    {
      "partNumber": "35120",
      "description": "4' X 4' DOUBLE"
    },
    {
      "partNumber": "35150",
      "description": "4' X 4' POLY SILK"
    },
    {
      "partNumber": "35180",
      "description": "4' X 4' CHINA SILK"
    },
    {
      "partNumber": "35210",
      "description": "4' X 4' 1/4 SILK"
    },
    {
      "partNumber": "35240",
      "description": "4' X 4' BLACK SILK"
    },
    {
      "partNumber": "35245",
      "description": "4' X 4' 1/4 BLACK SILK"
    },
    {
      "partNumber": "35256",
      "description": "4' X 4' CHROMA KEY BLUE"
    },
    {
      "partNumber": "35258",
      "description": "4' X 4' CHROMA KEY GREEN"
    },
    {
      "partNumber": "35262",
      "description": "4' X 4' DIGITAL BLUE FLOPPY"
    },
    {
      "partNumber": "35265",
      "description": "4' X 4' DIGITAL GREEN"
    },
    {
      "partNumber": "35300",
      "description": "4' X 4' LAVENDER"
    },
    {
      "partNumber": "35360",
      "description": "40” X 40” McGRID"
    },
    {
      "partNumber": "35365",
      "description": "4' X 4' MUSLIN BLEACHED FLOP DOWN"
    },
    {
      "partNumber": "35370",
      "description": "4' X 4' MUSLIN UNBLEACHED FLOP DOWN"
    },
    {
      "partNumber": "35375",
      "description": "4' X 4' REFRASIL"
    },
    {
      "partNumber": "35390",
      "description": "4' X 4' SOFT EGG CRATE 50 DEGREE"
    },
    {
      "partNumber": "35395",
      "description": "4' X 4' WAG FLAG"
    },
    {
      "partNumber": "35400",
      "description": "4' X 4' ULTRA BOUNCE FLOPPY"
    },
    {
      "partNumber": "35405",
      "description": "4' X 4' WHITE DUVATYNE FLOPPY"
    },
    {
      "partNumber": "35410",
      "description": "4' X 4' DAY BLUE FLOPPY"
    },
    {
      "partNumber": "35415",
      "description": "4' X 4' ULTRA / BOUNCE 4-WAY FLOP"
    },
    {
      "partNumber": "35450",
      "description": "4' X 4' WHITE OUT FLOP DOWN"
    },
    {
      "partNumber": "35480",
      "description": "4' X 4' METAL FLAG"
    },
    {
      "partNumber": "35510",
      "description": "4' X 4' EMPTY FRAME"
    },
    {
      "partNumber": "35520",
      "description": "5' X 5' EMPTY FRAME"
    },
    {
      "partNumber": "36520",
      "description": "24” X 48” SINGLE"
    },
    {
      "partNumber": "36530",
      "description": "24” X 48” DOUBLE"
    },
    {
      "partNumber": "37030",
      "description": "24” X 36” BLACK"
    },
    {
      "partNumber": "37035",
      "description": "24” X 36” FLOP DOWN"
    },
    {
      "partNumber": "37060",
      "description": "24” X 36” SINGLE"
    },
    {
      "partNumber": "37090",
      "description": "24” X 36” DOUBLE"
    },
    {
      "partNumber": "37120",
      "description": "24” X 36” POLY SILK"
    },
    {
      "partNumber": "37150",
      "description": "24” X 36” CHINA SILK"
    },
    {
      "partNumber": "37155",
      "description": "24” X 36” CHINA SILK BLACK"
    },
    {
      "partNumber": "37160",
      "description": "24” X 36” 1/4 SILK"
    },
    {
      "partNumber": "37170",
      "description": "24” X 36”  BLACK SILK"
    },
    {
      "partNumber": "37175",
      "description": "24” X 36” 1/4 BLACK SILK"
    },
    {
      "partNumber": "37210",
      "description": "24” X 36” LAVENDER"
    },
    {
      "partNumber": "37230",
      "description": "24” X 36” REFRASIL"
    },
    {
      "partNumber": "37240",
      "description": "24” X 36” DOUBLE SCRIM (METAL)"
    },
    {
      "partNumber": "37270",
      "description": "24” X 36” SINGLE SCRIM (METAL)"
    },
    {
      "partNumber": "37275",
      "description": "24'  X 36'  WATER FLOP"
    },
    {
      "partNumber": "37280",
      "description": "24” X 36” WHITE DUVATYNE FLOPPY"
    },
    {
      "partNumber": "37285",
      "description": "24” X 36” WHITE NET"
    },
    {
      "partNumber": "37295",
      "description": "24” X 36” EMPTY FRAME"
    },
    {
      "partNumber": "37300",
      "description": "24” X 36” EMPTY FRAME OPEN END"
    },
    {
      "partNumber": "37330",
      "description": "24” X 36” T-FLAG"
    },
    {
      "partNumber": "37360",
      "description": "24” X 36” METAL"
    },
    {
      "partNumber": "39240",
      "description": "EXTRA EARS FOR FRAMES"
    },
    {
      "partNumber": "39270",
      "description": "24” X 24” EMPTY FRAME"
    },
    {
      "partNumber": "39300",
      "description": "36” X 36” EMPTY FRAME"
    },
    {
      "partNumber": "39305",
      "description": "3' X 5' EMPTY FLAT FRAME"
    },
    {
      "partNumber": "40030",
      "description": "18” X 24” BLACK"
    },
    {
      "partNumber": "40035",
      "description": "18” X 24” FLOP DOWN"
    },
    {
      "partNumber": "40060",
      "description": "18” X 24” SINGLE"
    },
    {
      "partNumber": "40090",
      "description": "18” X 24” DOUBLE"
    },
    {
      "partNumber": "40120",
      "description": "18” X 24” POLY SILK"
    },
    {
      "partNumber": "40150",
      "description": "18” X 24” CHINA SILK"
    },
    {
      "partNumber": "40156",
      "description": "18” X 24” CHINA SILK BLACK"
    },
    {
      "partNumber": "40160",
      "description": "18” X 24” SILK BLACK"
    },
    {
      "partNumber": "40165",
      "description": "18” X 24” 1/4 SILK"
    },
    {
      "partNumber": "40175",
      "description": "18” X 24” 1/4 BLACK SILK"
    },
    {
      "partNumber": "40210",
      "description": "18” X 24” LAVENDER"
    },
    {
      "partNumber": "40250",
      "description": "18” X 24” REFRASIL"
    },
    {
      "partNumber": "40260",
      "description": "18” X 24” WHITE DUVATYNE"
    },
    {
      "partNumber": "40262",
      "description": "18” X 24” WHITE NET"
    },
    {
      "partNumber": "40266",
      "description": "18” X 24” EMPTY FRAME"
    },
    {
      "partNumber": "40270",
      "description": "18” X 24” METAL FLAG"
    },
    {
      "partNumber": "40275",
      "description": "18” X 24” T-FLAGS"
    },
    {
      "partNumber": "40280",
      "description": "18” X 24” OPEN END FRAME"
    },
    {
      "partNumber": "40300",
      "description": "18” X 24” OPEN EMPTY FRAME"
    },
    {
      "partNumber": "40520",
      "description": "12” X 20” SINGLE"
    },
    {
      "partNumber": "40540",
      "description": "12” X 20” DOUBLE"
    },
    {
      "partNumber": "40560",
      "description": "12” X 20” SOLID"
    },
    {
      "partNumber": "40580",
      "description": "12” X 20” SILK"
    },
    {
      "partNumber": "40600",
      "description": "12” X 20” BLACK SILK"
    },
    {
      "partNumber": "40700",
      "description": "12” X 20” LAVENDER"
    },
    {
      "partNumber": "40860",
      "description": "12” X 20” TRIPLE"
    },
    {
      "partNumber": "40950",
      "description": "12” X 20” OPEN END FRAME"
    },
    {
      "partNumber": "41030",
      "description": "12” X 16” BLACK"
    },
    {
      "partNumber": "41060",
      "description": "12” X 16” SINGLE"
    },
    {
      "partNumber": "41090",
      "description": "12” X 16” DOUBLE"
    },
    {
      "partNumber": "41120",
      "description": "12” X 16” POLY SILK"
    },
    {
      "partNumber": "41150",
      "description": "12” X 16” CHINA SILK"
    },
    {
      "partNumber": "41180",
      "description": "12” X 16” BLACK SILK"
    },
    {
      "partNumber": "41210",
      "description": "12” X 16” LAVENDER"
    },
    {
      "partNumber": "41860",
      "description": "12” X 16” TRIPLE"
    },
    {
      "partNumber": "41950",
      "description": "12” X 16” OPEN END FRAME"
    },
    {
      "partNumber": "42030",
      "description": "10” X 12” BLACK"
    },
    {
      "partNumber": "42060",
      "description": "10” X 12” SINGLE"
    },
    {
      "partNumber": "42090",
      "description": "10” X 12” DOUBLE"
    },
    {
      "partNumber": "42120",
      "description": "10” X 12” POLY SILK"
    },
    {
      "partNumber": "42150",
      "description": "10” X 12” CHINA SILK"
    },
    {
      "partNumber": "42180",
      "description": "10” X 12” BLACK SILK"
    },
    {
      "partNumber": "42210",
      "description": "10” X 12” LAVENDER"
    },
    {
      "partNumber": "42980",
      "description": "10” X 12” OPEN END FRAME"
    },
    {
      "partNumber": "43030",
      "description": "2” BLACK FINGER"
    },
    {
      "partNumber": "43060",
      "description": "2” SINGLE FINGER"
    },
    {
      "partNumber": "43090",
      "description": "2” DOUBLE FINGER"
    },
    {
      "partNumber": "43120",
      "description": "2” SILK FINGER"
    },
    {
      "partNumber": "43150",
      "description": "2” LAVENDER FINGER"
    },
    {
      "partNumber": "43170",
      "description": "2” BLACK SILK FINGER"
    },
    {
      "partNumber": "43180",
      "description": "4” BLACK FINGER"
    },
    {
      "partNumber": "43210",
      "description": "4” SINGLE FINGER"
    },
    {
      "partNumber": "43240",
      "description": "4” DOUBLE FINGER"
    },
    {
      "partNumber": "43270",
      "description": "4” SILK FINGER"
    },
    {
      "partNumber": "43300",
      "description": "4” LAVENDER FINGER"
    },
    {
      "partNumber": "43305",
      "description": "4” BLACK SILK FINGER"
    },
    {
      "partNumber": "43310",
      "description": "4” TRIPLE FINGER"
    },
    {
      "partNumber": "43320",
      "description": "4” EMPTY FRAME FINGER"
    },
    {
      "partNumber": "43330",
      "description": "6” BLACK FINGER"
    },
    {
      "partNumber": "43360",
      "description": "6” SINGLE FINGER"
    },
    {
      "partNumber": "43390",
      "description": "6” DOUBLE FINGER"
    },
    {
      "partNumber": "43420",
      "description": "6” SILK FINGER"
    },
    {
      "partNumber": "43450",
      "description": "6” LAVENDER FINGER"
    },
    {
      "partNumber": "43460",
      "description": "6” BLACK SILK FINGER"
    },
    {
      "partNumber": "43470",
      "description": "6” TRIPLE FINGER"
    },
    {
      "partNumber": "43480",
      "description": "6” EMPTY FRAME FINGER"
    },
    {
      "partNumber": "44030",
      "description": "3” BLACK DOT"
    },
    {
      "partNumber": "44060",
      "description": "3” SINGLE DOT"
    },
    {
      "partNumber": "44090",
      "description": "3” DOUBLE DOT"
    },
    {
      "partNumber": "44120",
      "description": "3” SILK DOT"
    },
    {
      "partNumber": "44150",
      "description": "3” LAVENDER DOT"
    },
    {
      "partNumber": "44160",
      "description": "3” BLACK SILK DOT"
    },
    {
      "partNumber": "44170",
      "description": "3” TRIPLE DOT"
    },
    {
      "partNumber": "44180",
      "description": "6” BLACK DOT"
    },
    {
      "partNumber": "44210",
      "description": "6” SINGLE DOT"
    },
    {
      "partNumber": "44240",
      "description": "6” DOUBLE DOT"
    },
    {
      "partNumber": "44270",
      "description": "6” SILK DOT"
    },
    {
      "partNumber": "44300",
      "description": "6” LAVENDER DOT"
    },
    {
      "partNumber": "44310",
      "description": "6” BLACK SILK DOT"
    },
    {
      "partNumber": "44320",
      "description": "6” TRIPLE DOT"
    },
    {
      "partNumber": "44330",
      "description": "9” BLACK DOT"
    },
    {
      "partNumber": "44360",
      "description": "9” SINGLE DOT"
    },
    {
      "partNumber": "44390",
      "description": "9” DOUBLE DOT"
    },
    {
      "partNumber": "44420",
      "description": "9” SILK DOT"
    },
    {
      "partNumber": "44450",
      "description": "9” LAVENDER DOT"
    },
    {
      "partNumber": "44460",
      "description": "9” BLACK SILK DOT"
    },
    {
      "partNumber": "44470",
      "description": "9” TRIPLE DOT"
    },
    {
      "partNumber": "44480",
      "description": "12” BLACK DOT"
    },
    {
      "partNumber": "44510",
      "description": "12” SINGLE DOT"
    },
    {
      "partNumber": "44540",
      "description": "12” DOUBLE DOT"
    },
    {
      "partNumber": "44570",
      "description": "12” SILK DOT"
    },
    {
      "partNumber": "44600",
      "description": "12” LAVENDER DOT"
    },
    {
      "partNumber": "44680",
      "description": "12” BLACK SILK DOT"
    },
    {
      "partNumber": "44700",
      "description": "12” TRIPLE DOT"
    },
    {
      "partNumber": "45030",
      "description": "BLACK CLIP-ON"
    },
    {
      "partNumber": "45060",
      "description": "SINGLE CLIP-ON"
    },
    {
      "partNumber": "45090",
      "description": "DOUBLE CLIP-ON"
    },
    {
      "partNumber": "45120",
      "description": "SILK CLIP-ON"
    },
    {
      "partNumber": "45150",
      "description": "LAVENDER CLIP-ON"
    },
    {
      "partNumber": "45170",
      "description": "BLACK SILK CLIP-ON"
    },
    {
      "partNumber": "45200",
      "description": "EMPTY FRAME CLIP-ON"
    },
    {
      "partNumber": "46030",
      "description": "18” X 24” CELLO CUCOLORIS"
    },
    {
      "partNumber": "46060",
      "description": "18” X 24”  WOOD CUCOLORIS"
    },
    {
      "partNumber": "46090",
      "description": "24” X 36” CELLO CUCOLORIS"
    },
    {
      "partNumber": "46120",
      "description": "24” X 36” WOOD CUCOLORIS"
    },
    {
      "partNumber": "46150",
      "description": "4' X 4' CELLO CUCOLORIS"
    },
    {
      "partNumber": "46180",
      "description": "4' X 4'  WOOD CUCOLORIS"
    },
    {
      "partNumber": "46210",
      "description": "MISC. WOOD STICKS"
    },
    {
      "partNumber": "47030",
      "description": "4' X 4' REFLECTOR SILVER"
    },
    {
      "partNumber": "47060",
      "description": "4' X 4' REFLECTOR GOLD"
    },
    {
      "partNumber": "47070",
      "description": "4' X 4' REFLECTOR GOLD/SILVER"
    },
    {
      "partNumber": "47090",
      "description": "REFLECTOR BOX - 2 PLACE"
    },
    {
      "partNumber": "47120",
      "description": "REFLECTOR BOX - 4 PLACE"
    },
    {
      "partNumber": "47150",
      "description": "REFLECTOR BOX - 6 PLACE"
    },
    {
      "partNumber": "47180",
      "description": "2' X 2' REFLECTOR SILVER"
    },
    {
      "partNumber": "47210",
      "description": "2' X 2' REFLECTOR GOLD"
    },
    {
      "partNumber": "47240",
      "description": "HAND REFLECTOR"
    },
    {
      "partNumber": "47270",
      "description": "REFLECTOR BOX - 2 PLACE (24”)"
    },
    {
      "partNumber": "47300",
      "description": "4' X 4'  MIRROR"
    },
    {
      "partNumber": "47320",
      "description": "4' X 4'  XENON MIRROR"
    },
    {
      "partNumber": "47322",
      "description": "MIRROR DROP DOWN"
    },
    {
      "partNumber": "47330",
      "description": "2' X 2'  MIRROR"
    },
    {
      "partNumber": "47362",
      "description": "MIRROR TREE, 4-PLACE"
    },
    {
      "partNumber": "47390",
      "description": "1' X 1'  MIRROR"
    },
    {
      "partNumber": "47600",
      "description": "REHEARSAL MIRROR 5' X 5' "
    },
    {
      "partNumber": "47610",
      "description": "4' X 8' ALUMINUM BOUNCE FRAMES"
    },
    {
      "partNumber": "47611",
      "description": "4' X 4' ALUMINUM BOUNCE FRAMES"
    },
    {
      "partNumber": "47630",
      "description": "CONVEX MIRROR 3'"
    },
    {
      "partNumber": "48030",
      "description": "FULL APPLE BOX"
    },
    {
      "partNumber": "48060",
      "description": "HALF APPLE BOX"
    },
    {
      "partNumber": "48090",
      "description": "QUARTER APPLE BOX"
    },
    {
      "partNumber": "48120",
      "description": "PANCAKE"
    },
    {
      "partNumber": "48150",
      "description": "FULL HALF APPLE (MIDGET)"
    },
    {
      "partNumber": "48180",
      "description": "HALF HALF APPLE"
    },
    {
      "partNumber": "48210",
      "description": "QUARTER HALF APPLE "
    },
    {
      "partNumber": "48240",
      "description": "SANDBAG, 35 LB. "
    },
    {
      "partNumber": "48270",
      "description": "SANDBAG, 25 LB. "
    },
    {
      "partNumber": "48290",
      "description": "SHOT BAG, 35 LB. "
    },
    {
      "partNumber": "48300",
      "description": "SHOT BAG, 20 LB. "
    },
    {
      "partNumber": "49030",
      "description": "CUP BLOCKS (SET)"
    },
    {
      "partNumber": "49060",
      "description": "STAIR BLOCKS (SET OF 4)"
    },
    {
      "partNumber": "49090",
      "description": "FULL BASSO BLOCKS (SET OF 12)"
    },
    {
      "partNumber": "49120",
      "description": "HALF BASSO BLOCKS (SET OF 24)"
    },
    {
      "partNumber": "49150",
      "description": "LOCK BLOCKS"
    },
    {
      "partNumber": "49180",
      "description": "BOX OF WEDGES"
    },
    {
      "partNumber": "49210",
      "description": "BOX OF CRIBBING 1 X 3"
    },
    {
      "partNumber": "49240",
      "description": "BOX OF CRIBBING 2 X 4"
    },
    {
      "partNumber": "49245",
      "description": "BOX OF PLYWOOD PADS"
    },
    {
      "partNumber": "49270",
      "description": "MILK CRATE"
    },
    {
      "partNumber": "49280",
      "description": "MILK CRATE 1/2 SIZE"
    },
    {
      "partNumber": "50030",
      "description": "LADDER, LITTLE GIANT"
    },
    {
      "partNumber": "50060",
      "description": "LADDER 4'"
    },
    {
      "partNumber": "50090",
      "description": "LADDER 6'"
    },
    {
      "partNumber": "50120",
      "description": "LADDER 8'"
    },
    {
      "partNumber": "50150",
      "description": "LADDER 10'"
    },
    {
      "partNumber": "50180",
      "description": "LADDER 12'"
    },
    {
      "partNumber": "50185",
      "description": "LADDER 14'"
    },
    {
      "partNumber": "50210",
      "description": "LADDER, 22' EXT."
    },
    {
      "partNumber": "50240",
      "description": "LADDER, 32' EXT."
    },
    {
      "partNumber": "50243",
      "description": "LADDER, 32 EXT - HALF (GREEN BEDS)"
    },
    {
      "partNumber": "50245",
      "description": "LADDER, LITTLE GIANT 17' EXT."
    },
    {
      "partNumber": "50270",
      "description": "LADDER, ROLLING TRESTLE"
    },
    {
      "partNumber": "50276",
      "description": "LADDER, ROLLING TRESTLE, MAX TO 22'"
    },
    {
      "partNumber": "50300",
      "description": "LADDER POD"
    },
    {
      "partNumber": "50330",
      "description": "LEVEL HEAD"
    },
    {
      "partNumber": "51030",
      "description": "6' X 6' PARALLEL SET"
    },
    {
      "partNumber": "51240",
      "description": "6' X 6' SIDES (SET OF 2)"
    },
    {
      "partNumber": "51270",
      "description": "DECKS (SET OF 2)"
    },
    {
      "partNumber": "51300",
      "description": "RAILS (SET OF 4)"
    },
    {
      "partNumber": "51315",
      "description": "POSTS (SET OF 4)"
    },
    {
      "partNumber": "51330",
      "description": "FEET (SET OF 4)"
    },
    {
      "partNumber": "51340",
      "description": "GRAVITY PIN "
    },
    {
      "partNumber": "51360",
      "description": "WHEELS (SET OF 4)"
    },
    {
      "partNumber": "51390",
      "description": "SCREWJACKS (SET 4)"
    },
    {
      "partNumber": "51420",
      "description": "3  X  6 PARALLEL SIDE (SET OF 2)"
    },
    {
      "partNumber": "52030",
      "description": "MEAT AXES W/ CHESEBORO"
    },
    {
      "partNumber": "52060",
      "description": "MEAT AXES W/C-CLAMP"
    },
    {
      "partNumber": "52090",
      "description": "MINI MEAT AXE"
    },
    {
      "partNumber": "52120",
      "description": "DECK POLES"
    },
    {
      "partNumber": "52150",
      "description": "FLEX ARM"
    },
    {
      "partNumber": "53020",
      "description": "1-1/4” SLEEVE 12”"
    },
    {
      "partNumber": "53030",
      "description": "1-1/4” SLEEVES 6”"
    },
    {
      "partNumber": "53050",
      "description": "1-1/4” 3-WAY CORNER"
    },
    {
      "partNumber": "53080",
      "description": "1-1/4” SPEEDRAIL ADJUST ANGLE RECEIVER"
    },
    {
      "partNumber": "53100",
      "description": "1-1/4” SPEEDRAIL C-CLAMPS (2 PIECE SET)"
    },
    {
      "partNumber": "53120",
      "description": "1-1/4” SPEEDRAIL SPREADERS (3 PIECE SET)"
    },
    {
      "partNumber": "53140",
      "description": "1-1/4” TELESCOPING SLEEVE"
    },
    {
      "partNumber": "53160",
      "description": "1-1/4” SPEEDRAIL OVER / UNDER"
    },
    {
      "partNumber": "53180",
      "description": "1-1/4” OVER/UNDER EARS (WIDE)"
    },
    {
      "partNumber": "53200",
      "description": "1-1/4” SPEEDRAIL STARTERS (POTATO) "
    },
    {
      "partNumber": "53220",
      "description": "1-1/4” MODERN PIPE BRACKETS (2 PIECE SET)"
    },
    {
      "partNumber": "53240",
      "description": "1-1/4” PIPE TO JR.  (CANDLESTICK MAKER)"
    },
    {
      "partNumber": "53260",
      "description": "1-1/4”  PIPE TO JR. MALE ADAPTER (MODERN)"
    },
    {
      "partNumber": "53280",
      "description": "1-1/4” SPEEDRAIL FRAME CORNER W/ BRACE"
    },
    {
      "partNumber": "53400",
      "description": "1-1/2” MODERN CORNERS"
    },
    {
      "partNumber": "53420",
      "description": "1-1/2” MODERN FRAME EARS"
    },
    {
      "partNumber": "53430",
      "description": "1-1/2” MODERN OFFSET EARS"
    },
    {
      "partNumber": "53440",
      "description": "1-1/2” SPEEDRAIL OVER/UNDER"
    },
    {
      "partNumber": "53460",
      "description": "1-1/2” MODERN MENACE, 3-PIECE SET"
    },
    {
      "partNumber": "53470",
      "description": "1-1/2'' 3 -WAY CORNER"
    },
    {
      "partNumber": "53480",
      "description": "1-1/2” SLEEVES 12” (FOR SPEEDRAIL)"
    },
    {
      "partNumber": "53500",
      "description": "1-1/2” SPEEDRAIL C-CLAMPS"
    },
    {
      "partNumber": "53520",
      "description": "1-1/2” SPEEDRAIL PIPE JR MALE ADAPTER (MODERN)"
    },
    {
      "partNumber": "53540",
      "description": "1-1/2” SPEEDRAIL SPREADERS (3 PIECE SET)"
    },
    {
      "partNumber": "53560",
      "description": "1-1/2” STEEL PIPE CONNECTOR"
    },
    {
      "partNumber": "53700",
      "description": "12K EAR EXTENSIONS (SET OF 3)"
    },
    {
      "partNumber": "53785",
      "description": "ANDERTON PIN"
    },
    {
      "partNumber": "53800",
      "description": "BABY C-CLAMP 4”"
    },
    {
      "partNumber": "53820",
      "description": "BABY C-CLAMP 6”"
    },
    {
      "partNumber": "53840",
      "description": "BABY C-CLAMP 8”"
    },
    {
      "partNumber": "53860",
      "description": "BABY C-CLAMP 10”"
    },
    {
      "partNumber": "53880",
      "description": "BABY C-CLAMP 12”"
    },
    {
      "partNumber": "53900",
      "description": "BABY GRID CLAMP (BOBBY WEST)"
    },
    {
      "partNumber": "53920",
      "description": "BABY NAIL-ON PLATE"
    },
    {
      "partNumber": "53940",
      "description": "BABY OFFSET ARM"
    },
    {
      "partNumber": "53960",
      "description": "BABY OFFSET SUPERS"
    },
    {
      "partNumber": "53980",
      "description": "BABY TRIPLE HEADER "
    },
    {
      "partNumber": "54000",
      "description": "BABY PIN 5/16” MALE THREAD"
    },
    {
      "partNumber": "54020",
      "description": "BABY PIN 5/16” FEMALE"
    },
    {
      "partNumber": "54040",
      "description": "BABY PIN 3/8” MALE THREAD"
    },
    {
      "partNumber": "54060",
      "description": "BABY PIN 3/8” FEMALE"
    },
    {
      "partNumber": "54080",
      "description": "BABY PIN 1/4” MALE THREAD"
    },
    {
      "partNumber": "54100",
      "description": "BABY PIN 1/4” FEMALE THREAD"
    },
    {
      "partNumber": "54105",
      "description": "BABY PIN 6” W/ 3/8” MALE THREAD"
    },
    {
      "partNumber": "54120",
      "description": "BABY PLATE 90 DEGREE"
    },
    {
      "partNumber": "54140",
      "description": "BABY PLATE HI RISE"
    },
    {
      "partNumber": "54160",
      "description": "BABY, RIGHT ANGLE PIN ADAPTER"
    },
    {
      "partNumber": "54180",
      "description": "BABY LIGHT SOCKET ADAPTER"
    },
    {
      "partNumber": "54190",
      "description": "BABY QUACKER"
    },
    {
      "partNumber": "54200",
      "description": "BABY RISER 6”"
    },
    {
      "partNumber": "54220",
      "description": "BABY RISER 12”"
    },
    {
      "partNumber": "54240",
      "description": "BABY RISER 18”"
    },
    {
      "partNumber": "54260",
      "description": "BABY RISER 24”"
    },
    {
      "partNumber": "54280",
      "description": "BABY SIDE ARM"
    },
    {
      "partNumber": "54400",
      "description": "BAILIN BRACKET"
    },
    {
      "partNumber": "54420",
      "description": "BEADBOARD HOLDER"
    },
    {
      "partNumber": "54440",
      "description": "BIG BEN CLAMP (GRID W/ JR. MALE PIN"
    },
    {
      "partNumber": "54460",
      "description": "BIG BITE BABY"
    },
    {
      "partNumber": "54480",
      "description": "CAMERA RISER 6”"
    },
    {
      "partNumber": "54500",
      "description": "CAMERA RISER 12”"
    },
    {
      "partNumber": "54520",
      "description": "CANDLE STICK"
    },
    {
      "partNumber": "54540",
      "description": "CANDLESTICK MAKER, 1-1/4” (3 PIECE SET) "
    },
    {
      "partNumber": "54560",
      "description": "CARDALLINI CLAMP - CENTER JAW"
    },
    {
      "partNumber": "54580",
      "description": "CARDALLINI CLAMP - END JAW"
    },
    {
      "partNumber": "54590",
      "description": "PYTHON CLAMP"
    },
    {
      "partNumber": "54600",
      "description": "C-CLAMP 4”"
    },
    {
      "partNumber": "54620",
      "description": "C-CLAMP 6”"
    },
    {
      "partNumber": "54640",
      "description": "C-CLAMP 8”"
    },
    {
      "partNumber": "54660",
      "description": "C-CLAMP 10”"
    },
    {
      "partNumber": "54680",
      "description": "C-CLAMP 12”"
    },
    {
      "partNumber": "54700",
      "description": "CHAIN VISE GRIP"
    },
    {
      "partNumber": "54720",
      "description": "CHAIN VISE GRIP w/SPUD"
    },
    {
      "partNumber": "54740",
      "description": "CONDOR BRACKETS"
    },
    {
      "partNumber": "54760",
      "description": "CANDLESTICK MAKER MODERN 1-1/2” (3 PC SET)"
    },
    {
      "partNumber": "54780",
      "description": "COUPLERS 2 X 4"
    },
    {
      "partNumber": "54800",
      "description": "CROWDER"
    },
    {
      "partNumber": "54820",
      "description": "DOLLY RISER"
    },
    {
      "partNumber": "54840",
      "description": "DROP CEILING CABLE HOLDER"
    },
    {
      "partNumber": "54860",
      "description": "DROP CEILING CLIP"
    },
    {
      "partNumber": "54880",
      "description": "FOAMCORE HOLDER"
    },
    {
      "partNumber": "54900",
      "description": "FURNITURE CLAMP 6” W/SPUD"
    },
    {
      "partNumber": "54920",
      "description": "FURNITURE CLAMP 12” W/SPUD"
    },
    {
      "partNumber": "54940",
      "description": "FURNITURE CLAMP 18” W/SPUD"
    },
    {
      "partNumber": "54960",
      "description": "FURNITURE CLAMP 24”W/SPUD"
    },
    {
      "partNumber": "54980",
      "description": "FURNITURE CLAMP 36” W/SPUD"
    },
    {
      "partNumber": "55000",
      "description": "GAFFER GRIP"
    },
    {
      "partNumber": "55020",
      "description": "GATOR GRIP w/SPUD"
    },
    {
      "partNumber": "55040",
      "description": "GRIP SAVER"
    },
    {
      "partNumber": "55060",
      "description": "GRIP SAVER & INTEGRATED LOLLIPOP"
    },
    {
      "partNumber": "55080",
      "description": "GRID CLAMP W/EARS"
    },
    {
      "partNumber": "55100",
      "description": "HI-HAT"
    },
    {
      "partNumber": "55120",
      "description": "HOLDER 1 X 3"
    },
    {
      "partNumber": "55140",
      "description": "HOLDER 2 X 4"
    },
    {
      "partNumber": "55150",
      "description": "HOLDER, FLAT FRAME / 4'X 4'"
    },
    {
      "partNumber": "55160",
      "description": "JR SPUD SLIDER (ADDITIONAL)"
    },
    {
      "partNumber": "55180",
      "description": "JR. C-CLAMP 4”"
    },
    {
      "partNumber": "55200",
      "description": "JR. C-CLAMP 6”"
    },
    {
      "partNumber": "55220",
      "description": "JR. C-CLAMP 8”"
    },
    {
      "partNumber": "55240",
      "description": "JR. C-CLAMP 10”"
    },
    {
      "partNumber": "55260",
      "description": "JR. C-CLAMP 12”"
    },
    {
      "partNumber": "55280",
      "description": "JR. GRID CLAMP"
    },
    {
      "partNumber": "55300",
      "description": "JR. GRID CLAMP SIDE MOUNT"
    },
    {
      "partNumber": "55310",
      "description": "JR. TRUSS CLAMPS"
    },
    {
      "partNumber": "55320",
      "description": "JR. NAIL-ON PLATE"
    },
    {
      "partNumber": "55340",
      "description": "JR. KENO OFFSET"
    },
    {
      "partNumber": "55360",
      "description": "JR. OFFSET ARM"
    },
    {
      "partNumber": "55380",
      "description": "JR TRIPLE HEADER"
    },
    {
      "partNumber": "55400",
      "description": "JR. PIPE CLAMP "
    },
    {
      "partNumber": "55420",
      "description": "JR. RISER"
    },
    {
      "partNumber": "55440",
      "description": "JR. SIDE ARM"
    },
    {
      "partNumber": "55460",
      "description": "JR. TO BABY ADAPTER"
    },
    {
      "partNumber": "55480",
      "description": "KANT-TWIST CLAMP W/BABY PIN"
    },
    {
      "partNumber": "55500",
      "description": "KINO ARM, 90 DEGREE"
    },
    {
      "partNumber": "55520",
      "description": "LOW HAT"
    },
    {
      "partNumber": "55540",
      "description": "MAFER CLAMP"
    },
    {
      "partNumber": "55560",
      "description": "MAFER CLAMP w/SPUD"
    },
    {
      "partNumber": "55580",
      "description": "MAGIC ARMS"
    },
    {
      "partNumber": "55600",
      "description": "MENACE ARM, MATTHEWS, BABY"
    },
    {
      "partNumber": "55620",
      "description": "MENACE ARM, MATTHEWS, JR."
    },
    {
      "partNumber": "55640",
      "description": "MENACE ARM, MODERN 1-1/4” (3PCS SET)"
    },
    {
      "partNumber": "55660",
      "description": "MENACE ARM, MODERN 1-1/2” (3PCS SET)"
    },
    {
      "partNumber": "55680",
      "description": "MODERN PROCESS HELICOPTER, 3 PC. SET"
    },
    {
      "partNumber": "55700",
      "description": "MODERN TEE 1-1/4”"
    },
    {
      "partNumber": "55720",
      "description": "MODERN TEE 1-1/2”"
    },
    {
      "partNumber": "55800",
      "description": "MINI BABY 3-WAY ADAPTER"
    },
    {
      "partNumber": "55900",
      "description": "NORMS PIN 5/8” TO 3/8”"
    },
    {
      "partNumber": "55904",
      "description": "NORMS PIN MODERN"
    },
    {
      "partNumber": "56000",
      "description": "OVER/UNDER SWIVEL PIPE EAR, 1-1/4”"
    },
    {
      "partNumber": "56100",
      "description": "PIPE CLAMP 18” W/SPUD"
    },
    {
      "partNumber": "56120",
      "description": "PIPE CLAMP 24” W/SPUD"
    },
    {
      "partNumber": "56140",
      "description": "PIPE CLAMP 36” W/SPUD"
    },
    {
      "partNumber": "56160",
      "description": "PIPE CLAMP 48” W/SPUD"
    },
    {
      "partNumber": "56180",
      "description": "PIPE CLAMP 60” W/SPUD"
    },
    {
      "partNumber": "56200",
      "description": "PIPE CLAMP 72” W/SPUD"
    },
    {
      "partNumber": "56220",
      "description": "PIPE JR. ADAPTER FOR 1-1/4”"
    },
    {
      "partNumber": "56240",
      "description": "BABY SPUD SLIDER (ADDITIONAL) "
    },
    {
      "partNumber": "56400",
      "description": "POLE CAT, SMALL (2.5' - 4.5')"
    },
    {
      "partNumber": "56420",
      "description": "POLE CAT, MED. (4.5' - 8.1')"
    },
    {
      "partNumber": "56440",
      "description": "POLE CAT, LRG. (7' - 12')"
    },
    {
      "partNumber": "56600",
      "description": "PROBURGER, BABY PIN"
    },
    {
      "partNumber": "56620",
      "description": "PROBURGER, RIDGID"
    },
    {
      "partNumber": "56640",
      "description": "PROBURGER, SWIVEL"
    },
    {
      "partNumber": "56800",
      "description": "PUTTY KNIFE w/SPUD"
    },
    {
      "partNumber": "57000",
      "description": "SLIDERS 2 X 4 W/EARS"
    },
    {
      "partNumber": "57100",
      "description": "TOE KNACKS"
    },
    {
      "partNumber": "57200",
      "description": "TREE BRANCH HOLDER"
    },
    {
      "partNumber": "57220",
      "description": "TREE GAG BABY"
    },
    {
      "partNumber": "57240",
      "description": "TREE GAG JUNIOR"
    },
    {
      "partNumber": "57400",
      "description": "TRUSSMAKER, MINI 1-1/4”"
    },
    {
      "partNumber": "57420",
      "description": "TRUSSMAKER, MINI 1-1/4”  W/ EARS"
    },
    {
      "partNumber": "57440",
      "description": "TRUSSMAKER 1-1/4”"
    },
    {
      "partNumber": "57460",
      "description": "TRUSSMAKER EARS W/ JR. PIN"
    },
    {
      "partNumber": "57480",
      "description": "TRUSSMAKERS, 1-1/4” W/ EARS"
    },
    {
      "partNumber": "57500",
      "description": "TRUSSMAKER 1-1/4” LADDER 6”"
    },
    {
      "partNumber": "57520",
      "description": "TRUSSMAKER 1-1/4” LADDER 12”"
    },
    {
      "partNumber": "57540",
      "description": "TRUSSMAKER 1-1/2” LADDER 12”"
    },
    {
      "partNumber": "57560",
      "description": "TRUSSMAKER 1-1/2”"
    },
    {
      "partNumber": "57580",
      "description": "TRUSSMAKERS, LADDER 1-1/4”"
    },
    {
      "partNumber": "57700",
      "description": "WALL SPREADER 2 X 6 (3 PIECE SET)"
    },
    {
      "partNumber": "57720",
      "description": "WALL SPREADER 2 X 4 (3 PIECE SET)"
    },
    {
      "partNumber": "57800",
      "description": "2  X 4 COUPLER"
    },
    {
      "partNumber": "57820",
      "description": "2 X 4 HOLDER W/ JR PIN"
    },
    {
      "partNumber": "57840",
      "description": "2 X 4 SLIDER W/ BABY PIN & JR RECEIVER"
    },
    {
      "partNumber": "57860",
      "description": "2 X 6 EAR"
    },
    {
      "partNumber": "57880",
      "description": "2 X 6 SLIDER W/ BABY PIN & JR RECEIVER"
    },
    {
      "partNumber": "58050",
      "description": "4 X 4 CART"
    },
    {
      "partNumber": "58051",
      "description": "4  X 4 GRANDE"
    },
    {
      "partNumber": "58100",
      "description": "CENTURY STAND CART"
    },
    {
      "partNumber": "58101",
      "description": "CENTURY STAND UTILITY CART"
    },
    {
      "partNumber": "58150",
      "description": "DITTY TOOL CART"
    },
    {
      "partNumber": "58155",
      "description": "SMALL GRIP CART, MODERN"
    },
    {
      "partNumber": "58200",
      "description": "DOES ALL CART"
    },
    {
      "partNumber": "58250",
      "description": "DOLLY PART CART"
    },
    {
      "partNumber": "58300",
      "description": "DOLLY TRACK/PLYWOOD CART"
    },
    {
      "partNumber": "58350",
      "description": "FLAG BOX CART"
    },
    {
      "partNumber": "58400",
      "description": "SANDBAG CART"
    },
    {
      "partNumber": "58450",
      "description": "TACO CART"
    },
    {
      "partNumber": "58451",
      "description": "TACO GRANDE"
    },
    {
      "partNumber": "58452",
      "description": "METAL SCRIM BOX"
    },
    {
      "partNumber": "58455",
      "description": "WEDGE HAMPER"
    },
    {
      "partNumber": "59030",
      "description": "CAMERA BAG"
    },
    {
      "partNumber": "59060",
      "description": "CAMERA CARPET 4 X 4"
    },
    {
      "partNumber": "59090",
      "description": "CAMERA TIE DOWN"
    },
    {
      "partNumber": "59120",
      "description": "FURNITURE PAD"
    },
    {
      "partNumber": "60125",
      "description": "2' STARTER RAMP ALUMINUM SCISSOR TRACK"
    },
    {
      "partNumber": "60126",
      "description": "2' ALUMINUM SCISSOR TRACK"
    },
    {
      "partNumber": "60127",
      "description": "4' ALUMINUM SCISSOR TRACK"
    },
    {
      "partNumber": "60129",
      "description": "8' ALUMINUM SCISSOR TRACK"
    },
    {
      "partNumber": "60130",
      "description": "10' ALUMINUM SCISSOR TRACK"
    },
    {
      "partNumber": "60140",
      "description": "ALTURNA MATS, 4' X 8'"
    },
    {
      "partNumber": "60300",
      "description": "DOLLY TRACK WHEELS (SKATEBOARD) SET OF 2"
    },
    {
      "partNumber": "60320-BC",
      "description": "DANA DOLLY KIT"
    },
    {
      "partNumber": "60325",
      "description": "DUTTI DOLLY"
    },
    {
      "partNumber": "60330",
      "description": "DOORWAY DOLLY"
    },
    {
      "partNumber": "60360",
      "description": "DOORWAY DOLLY TRACK WHEELS"
    },
    {
      "partNumber": "60390",
      "description": "EXTRA PUSH BARS"
    },
    {
      "partNumber": "60450",
      "description": "WESTERN DOLLY"
    },
    {
      "partNumber": "61010",
      "description": "BAZOOKA, NON-HYDRAULIC"
    },
    {
      "partNumber": "61060",
      "description": "CAMERA 4-WAY LEVEL HEAD"
    },
    {
      "partNumber": "61065",
      "description": "SPIDER HI-HAT W/ MITCHELL PLATE"
    },
    {
      "partNumber": "61085",
      "description": "CAR MOUNT, MODERN SPEEDRAIL KIT"
    },
    {
      "partNumber": "61090",
      "description": "CAMERA HOOD MOUNT"
    },
    {
      "partNumber": "61120",
      "description": "DOOR HOSTESS TRAY"
    },
    {
      "partNumber": "61130",
      "description": "CAMERA RISER SPEED RAIL"
    },
    {
      "partNumber": "61140",
      "description": "CAMERA 5/8” ROD KIT"
    },
    {
      "partNumber": "61150",
      "description": "MAGAZINE CLAMP"
    },
    {
      "partNumber": "61180",
      "description": "RATCHET STRAP"
    },
    {
      "partNumber": "61185",
      "description": "2' CAMERA SLIDER"
    },
    {
      "partNumber": "61210",
      "description": "SUCTION CUPS w/SPUD"
    },
    {
      "partNumber": "61230",
      "description": "UNIBODY CLAMPS"
    },
    {
      "partNumber": "62030",
      "description": "10' X 10' EZ-UP"
    },
    {
      "partNumber": "62060",
      "description": "EZ-UP SIDES 10', EACH"
    },
    {
      "partNumber": "62090",
      "description": "10' X 15' EZ-UP"
    },
    {
      "partNumber": "62091",
      "description": "10' X 20' EZ UP"
    },
    {
      "partNumber": "62092",
      "description": "EZ-UP BAG"
    },
    {
      "partNumber": "62215",
      "description": "E-TRACK D RING"
    },
    {
      "partNumber": "62220",
      "description": "ROPE RATCHET TIE DOWN"
    },
    {
      "partNumber": "62240",
      "description": "HAND TRUCKS"
    },
    {
      "partNumber": "62270",
      "description": "UMBRELLA"
    },
    {
      "partNumber": "63029",
      "description": "BLOCK & FALL, 2:1"
    },
    {
      "partNumber": "63030",
      "description": "BLOCK & FALL, 3:2"
    },
    {
      "partNumber": "63052-BC",
      "description": "CHAIN MOTOR 1/4-TON PROSTAR B/C"
    },
    {
      "partNumber": "63062",
      "description": "CHAIN MOTOR 1/2-TON B/C"
    },
    {
      "partNumber": "63064-BC",
      "description": "CHAIN MOTOR 1/2-TON 120V B/C"
    },
    {
      "partNumber": "63076-BC",
      "description": "CHAIN MOTOR HIGH SPEED DOUBLE HOOK B/C"
    },
    {
      "partNumber": "63076BC",
      "description": "SINGLE MOTOR BREAKER"
    },
    {
      "partNumber": "63092-BC",
      "description": "CHAIN MOTOR 1-TON B/C"
    },
    {
      "partNumber": "63094-BC",
      "description": "CHAIN MOTOR 1-TON 120V B/C"
    },
    {
      "partNumber": "63120",
      "description": "CHAIN BAG (BURLAP)"
    },
    {
      "partNumber": "63210-BC",
      "description": "8X DISTRO B/C"
    },
    {
      "partNumber": "63213-BC",
      "description": "4 -WAY DISTRO  B/C"
    },
    {
      "partNumber": "63230",
      "description": "SPIDERBOX"
    },
    {
      "partNumber": "63250-BC",
      "description": "8X PENDANT B/C"
    },
    {
      "partNumber": "63270-BC",
      "description": "4X PENDANT"
    },
    {
      "partNumber": "63420",
      "description": "50' MOTOR CONTROL CABLE "
    },
    {
      "partNumber": "63450",
      "description": "75' MOTOR CONTROL CABLE "
    },
    {
      "partNumber": "63480",
      "description": "100' MOTOR CONTROL CABLE"
    },
    {
      "partNumber": "63483",
      "description": "100' MOTOR CONTROL CABLE SOCAPEX"
    },
    {
      "partNumber": "6350B-BC",
      "description": "PENDANT/ 16 WAY PENDANT (DUAL PORT) B/C"
    },
    {
      "partNumber": "63510",
      "description": "50' POWER CORD"
    },
    {
      "partNumber": "63515",
      "description": "75' POWER CORD"
    },
    {
      "partNumber": "63520",
      "description": "100' POWER CORD"
    },
    {
      "partNumber": "63540",
      "description": "50' PENDANT CABLE"
    },
    {
      "partNumber": "63550",
      "description": "100' PENDANT CABLE"
    },
    {
      "partNumber": "63630",
      "description": "5/8” PEAR LINK"
    },
    {
      "partNumber": "63660",
      "description": "5/8” SPA SHACKLE"
    },
    {
      "partNumber": "63690",
      "description": "2' 3/8” GA AC SLING"
    },
    {
      "partNumber": "63720",
      "description": "5' 3/8” GA AC SLING"
    },
    {
      "partNumber": "63750",
      "description": "10' 3/8” GA AC SLING"
    },
    {
      "partNumber": "63780",
      "description": "20' 3/8” GA AC SLING"
    },
    {
      "partNumber": "63810",
      "description": "30' 3/8” GA AC SLING"
    },
    {
      "partNumber": "63840",
      "description": "SPANSET, 1.5'"
    },
    {
      "partNumber": "63870",
      "description": "SPANSET, 3'"
    },
    {
      "partNumber": "63875",
      "description": "SPANSET W/GAC INSERT 3'"
    },
    {
      "partNumber": "63880",
      "description": "SPANSET, 4'"
    },
    {
      "partNumber": "63900",
      "description": "SPANSET, 6'"
    },
    {
      "partNumber": "63905",
      "description": "SPANSET W/GAC INSERT 6'"
    },
    {
      "partNumber": "63930",
      "description": "SPANSET, 9'"
    },
    {
      "partNumber": "63960",
      "description": "SPANSET, 12'"
    },
    {
      "partNumber": "64019-BC",
      "description": "BOX TRUSS, 2' - 12” BLACK"
    },
    {
      "partNumber": "64020-BC",
      "description": "BOX TRUSS, 2' - 12” SILVER"
    },
    {
      "partNumber": "64023-BC",
      "description": "BOX TRUSS, 3' - 12” BLACK"
    },
    {
      "partNumber": "64024-BC",
      "description": "BOX TRUSS, 4' - 12” BLACK"
    },
    {
      "partNumber": "64025-BC",
      "description": "BOX TRUSS, 4' - 12” SILVER"
    },
    {
      "partNumber": "64029-BC",
      "description": "BOX TRUSS, 5' - 12” BLACK"
    },
    {
      "partNumber": "64030-BC",
      "description": "BOX TRUSS, 5' - 12” SILVER"
    },
    {
      "partNumber": "64034-BC",
      "description": "BOX TRUSS, 6' - 12” BLACK"
    },
    {
      "partNumber": "64035-BC",
      "description": "BOX TRUSS, 6' - 12” SILVER"
    },
    {
      "partNumber": "64059-BC",
      "description": "BOX TRUSS, 8' - 12” BLACK"
    },
    {
      "partNumber": "64060-BC",
      "description": "BOX TRUSS, 8' - 12” SILVER"
    },
    {
      "partNumber": "64089-BC",
      "description": "BOX TRUSS, 10' - 12” BLACK"
    },
    {
      "partNumber": "64090-BC",
      "description": "BOX TRUSS, 10' - 12” SILVER"
    },
    {
      "partNumber": "64099-BC",
      "description": "BOX TRUSS, 12” 45 DEGREE BLOCK BLACK"
    },
    {
      "partNumber": "64100-BC",
      "description": "BOX TRUSS, 12” 45 DEGREE BLOCK SILVER"
    },
    {
      "partNumber": "64119-BC",
      "description": "BOX TRUSS, 12” 6-WAY CORNER BLOCK BLACK"
    },
    {
      "partNumber": "64120-BC",
      "description": "BOX TRUSS, 12” 6-WAY CORNER BLOCK SILVER"
    },
    {
      "partNumber": "64122",
      "description": "BOX TRUSS, 12” & 20” TRUSS BASE PLATE SILVER"
    },
    {
      "partNumber": "64123-BC",
      "description": "BOX TRUSS, 2' - 20.5” BLACK"
    },
    {
      "partNumber": "64124-BC",
      "description": "BOX TRUSS, 4' - 20.5” BLACK"
    },
    {
      "partNumber": "64124BC",
      "description": "BOX TRUSS, 2' - 20.5” SILVERbc"
    },
    {
      "partNumber": "64125-BC",
      "description": "BOX TRUSS, 4' - 20.5” SILVER"
    },
    {
      "partNumber": "64149-BC",
      "description": "BOX TRUSS, 5' - 20.5” BLACK"
    },
    {
      "partNumber": "64150-BC",
      "description": "BOX TRUSS, 5' - 20.5” SILVER"
    },
    {
      "partNumber": "64159-BC",
      "description": "BOX TRUSS, 6' - 20.5” BLACK"
    },
    {
      "partNumber": "64160-BC",
      "description": "BOX TRUSS, 6' - 20.5” SILVER"
    },
    {
      "partNumber": "64179-BC",
      "description": "BOX TRUSS, 8' - 20.5” BLACK"
    },
    {
      "partNumber": "64180-BC",
      "description": "BOX TRUSS, 8' - 20.5” SILVER"
    },
    {
      "partNumber": "64209-BC",
      "description": "BOX TRUSS, 10' - 20.5” BLACK"
    },
    {
      "partNumber": "64210-BC",
      "description": "BOX TRUSS, 10' - 20.5” SILVER"
    },
    {
      "partNumber": "64230-BC",
      "description": "BOX TRUSS, 20.5” 45 DEGREE BLOCK"
    },
    {
      "partNumber": "64240-BC",
      "description": "BOX TRUSS, 20.5” 6-WAY CORNER BLOCK"
    },
    {
      "partNumber": "64250-BC",
      "description": "BOX TRUSS, 20.5” 3” SPACER"
    },
    {
      "partNumber": "64256-BC",
      "description": "BOX TRUSS, 20.5” 6” SPACER"
    },
    {
      "partNumber": "64256B-BC",
      "description": "BOX TRUSS /12” X 6” SPACER BLOCK"
    },
    {
      "partNumber": "64260",
      "description": "GRAPPLE, 12”  (SET OF TWO)"
    },
    {
      "partNumber": "64265",
      "description": "GRAPPLE, 20” (SET OF TWO)"
    },
    {
      "partNumber": "64266",
      "description": "CONCRETE BLOCKS, 1000 LB BALLAST"
    },
    {
      "partNumber": "64268-BC",
      "description": "#1200 MINI G-BLOCKS W/ JACKS"
    },
    {
      "partNumber": "64270",
      "description": "BOX TRUSS BOLT"
    },
    {
      "partNumber": "64280",
      "description": "BOX TRUSS,  RATCHET"
    },
    {
      "partNumber": "64290",
      "description": "BOX TRUSS, WRENCH"
    },
    {
      "partNumber": "64610-BC",
      "description": "MOD TRUSS, 6” X 3'"
    },
    {
      "partNumber": "64615-BC",
      "description": "MOD TRUSS, 6” X 4'"
    },
    {
      "partNumber": "64620-BC",
      "description": "MOD TRUSS, 6” X 5'"
    },
    {
      "partNumber": "64630-BC",
      "description": "MOD TRUSS, 6” X 7'"
    },
    {
      "partNumber": "64635-BC",
      "description": "MOD TRUSS, 6” X 8'"
    },
    {
      "partNumber": "64660-BC",
      "description": "MODD TRUSS, 6” END BLOCK"
    },
    {
      "partNumber": "64680",
      "description": "MOD TRUSS, 6” X 12” SPLICE PLATE"
    },
    {
      "partNumber": "64685",
      "description": "MOD TRUSS, PIPE ADAPTER"
    },
    {
      "partNumber": "64690",
      "description": "MOD TRUSS, BOLT"
    },
    {
      "partNumber": "65030",
      "description": "20' X 20' IRRIGATION PIPE FRAME"
    },
    {
      "partNumber": "65060",
      "description": "20' X 30' IRRIGATION PIPE FRAME"
    },
    {
      "partNumber": "65090",
      "description": "30' X 30' IRRIGATION PIPE FRAME"
    },
    {
      "partNumber": "65120",
      "description": "30' X 40' IRRIGATION PIPE FRAME"
    },
    {
      "partNumber": "65150",
      "description": "40' X 40' IRRIGATION PIPE FRAME"
    },
    {
      "partNumber": "6540-BC",
      "description": "PENDANT CABLE ADAPTER"
    },
    {
      "partNumber": "66020",
      "description": "STEEL DECK, 2' X 4' "
    },
    {
      "partNumber": "66025",
      "description": "STEEL DECK, 2' X 6'"
    },
    {
      "partNumber": "66030",
      "description": "STEEL DECK, 2' X 8' "
    },
    {
      "partNumber": "66050",
      "description": "STEEL DECK, 4' X 4' "
    },
    {
      "partNumber": "66052",
      "description": "STEEL DECK, 4' PIE"
    },
    {
      "partNumber": "66055",
      "description": "STEEL DECK, 4' X 6' "
    },
    {
      "partNumber": "66060",
      "description": "STEEL DECK, 4' X 8' "
    },
    {
      "partNumber": "66065",
      "description": "STEEL DECK, 4' X 8' WATER DECK"
    },
    {
      "partNumber": "66070",
      "description": "STEEL DECK, CROW'S FEET"
    },
    {
      "partNumber": "66075",
      "description": "STEEL DECK, HANDRAIL BOX HELPER"
    },
    {
      "partNumber": "66080",
      "description": "STEEL DECK, PIG EARS"
    },
    {
      "partNumber": "66085",
      "description": "STEEL DECK HANDRAIL"
    },
    {
      "partNumber": "66090",
      "description": "STEEL DECK SAFETY RAIL 2'"
    },
    {
      "partNumber": "66095",
      "description": "STEEL DECK SAFETY RAIL 4'"
    },
    {
      "partNumber": "66110",
      "description": "STEEL DECK SCREWJACK W/FEET SHORT"
    },
    {
      "partNumber": "66115",
      "description": "STEEL DECK SCREWJACK W/FEET LONG"
    },
    {
      "partNumber": "66130",
      "description": "STEEL DECK SCREWJACK FOR DECKWHEELS SHORT"
    },
    {
      "partNumber": "66135",
      "description": "STEEL DECK SCREWJACK FOR DECKWHEELS LONG"
    },
    {
      "partNumber": "66137",
      "description": "STEEL DECK SCREWJACK W/WHEEL SHORT"
    },
    {
      "partNumber": "66138",
      "description": "STEEL DECK SCREWJACK W/WHEEL LONG"
    },
    {
      "partNumber": "66140",
      "description": "STEEL DECK INSET POST"
    },
    {
      "partNumber": "66150",
      "description": "STEEL DECK WHEELS"
    },
    {
      "partNumber": "66151",
      "description": "STEEL DECK 8” SWIVEL CASTER"
    },
    {
      "partNumber": "66154",
      "description": "STEEL DECK LOW PROFILE WHEELS"
    },
    {
      "partNumber": "66155",
      "description": "STEEL DECK WHEEL DOLLY"
    },
    {
      "partNumber": "66170",
      "description": "STEEL DECK ADJUSTABLE STAIRS 5-STEP"
    },
    {
      "partNumber": "66175",
      "description": "STEEL DECK, ADJUSTABLE STAIRS 7-STEP"
    },
    {
      "partNumber": "67050",
      "description": "ALUMA I-BEAMS, 21'  (W/ WOOD INSERTS)"
    },
    {
      "partNumber": "67090",
      "description": "I-BEAM, 8'  FOR RIGGING MOTORS"
    },
    {
      "partNumber": "67095",
      "description": "ALUMA I BEAMS, 12'  (W/ WOOD INSERTS)"
    },
    {
      "partNumber": "67100",
      "description": "I-BEAM, 10'  (ALUM)"
    },
    {
      "partNumber": "67120",
      "description": "I-BEAM, 20'  (ALUM)"
    },
    {
      "partNumber": "67122",
      "description": "LADDER TRUSS, 12” X 10' "
    },
    {
      "partNumber": "67123",
      "description": "LADDER TRUSS, 12” X 20'"
    },
    {
      "partNumber": "67124",
      "description": "SAFETY CABLE"
    },
    {
      "partNumber": "67125",
      "description": "I-BEAM-CLAMP"
    },
    {
      "partNumber": "67130",
      "description": "CABLE CARRIER"
    },
    {
      "partNumber": "67135",
      "description": "I-BEAM END STOP"
    },
    {
      "partNumber": "67140",
      "description": "I-BEAM TROLLEY JR."
    },
    {
      "partNumber": "67142",
      "description": "I-BEAM TROLLEY MOTOR"
    },
    {
      "partNumber": "67145",
      "description": "TRUSS TO I-BEAM HOLDER 12”"
    },
    {
      "partNumber": "67150",
      "description": "TRUSS TO I-BEAM HOLDER 20”"
    },
    {
      "partNumber": "67155",
      "description": "GAS PIPE (PER FOOT)"
    },
    {
      "partNumber": "67155B",
      "description": "GAS PIPE CONNECTOR"
    },
    {
      "partNumber": "67156",
      "description": "IRRIGATION PIPE, 2' "
    },
    {
      "partNumber": "67157",
      "description": "IRRIGATION PIPE, 4' "
    },
    {
      "partNumber": "67158",
      "description": "IRRIGATION PIPE, 6' "
    },
    {
      "partNumber": "67159",
      "description": "IRRIGATION PIPE, 8'"
    },
    {
      "partNumber": "67160",
      "description": "IRRIGATION PIPE, 10' "
    },
    {
      "partNumber": "67170",
      "description": "IRRIGATION PIPE, 16' "
    },
    {
      "partNumber": "67173",
      "description": "IRRIGATION PIPE, 18' "
    },
    {
      "partNumber": "67180",
      "description": "IRRIGATION PIPE, 20' "
    },
    {
      "partNumber": "67185",
      "description": "IRRIGATION PIPE, 24' "
    },
    {
      "partNumber": "67189",
      "description": "IRRIGATION PIPE, 30' "
    },
    {
      "partNumber": "67205",
      "description": "IRRIGATION PIPE CORNER (EACH)"
    },
    {
      "partNumber": "67210",
      "description": "IRRIGATION PIPE COUPLER"
    },
    {
      "partNumber": "67215",
      "description": "IRRIGATION PIPE EARS (EACH)"
    },
    {
      "partNumber": "67220",
      "description": "IRRIGATION PIPE TEES"
    },
    {
      "partNumber": "67240",
      "description": "SPEEDRAIL, 1-1/4” X  2'"
    },
    {
      "partNumber": "67242",
      "description": "SPEEDRAIL, 1-1/4” X  3'"
    },
    {
      "partNumber": "67250",
      "description": "SPEEDRAIL, 1-1/4” X  4'"
    },
    {
      "partNumber": "67255",
      "description": "SPEEDRAIL, 1-1/4” X  5'"
    },
    {
      "partNumber": "67260",
      "description": "SPEEDRAIL, 1-1/4” X  6'"
    },
    {
      "partNumber": "67265",
      "description": "SPEEDRAIL, 1-1/4” X  7'"
    },
    {
      "partNumber": "67270",
      "description": "SPEEDRAIL, 1-1/4” X  8'"
    },
    {
      "partNumber": "67280",
      "description": "SPEEDRAIL, 1-1/4” X 10'"
    },
    {
      "partNumber": "67290",
      "description": "SPEEDRAIL, 1-1/4” X 12'"
    },
    {
      "partNumber": "67300",
      "description": "SPEEDRAIL, 1-1/4” X 14'"
    },
    {
      "partNumber": "67305",
      "description": "SPEEDRAIL, 1-1/4” X 15'"
    },
    {
      "partNumber": "67310",
      "description": "SPEEDRAIL, 1-1/4” X 16'"
    },
    {
      "partNumber": "67320",
      "description": "SPEEDRAIL, 1-1/4” X 18'"
    },
    {
      "partNumber": "67325",
      "description": "SPEEDRAIL, 1-1/4” X 19'"
    },
    {
      "partNumber": "67330",
      "description": "SPEEDRAIL, 1-1/4” X 20'"
    },
    {
      "partNumber": "67400",
      "description": "SPEEDRAIL, 1-1/2” X  2'"
    },
    {
      "partNumber": "67410",
      "description": "SPEEDRAIL, 1-1/2” X  4'"
    },
    {
      "partNumber": "67415",
      "description": "SPEEDRAIL, 1-1/2” X  5'"
    },
    {
      "partNumber": "67420",
      "description": "SPEEDRAIL, 1-1/2” X  6'"
    },
    {
      "partNumber": "67425",
      "description": "SPEEDRAIL, 1-1/2” X  7'"
    },
    {
      "partNumber": "67430",
      "description": "SPEEDRAIL, 1-1/2” X  8'"
    },
    {
      "partNumber": "67440",
      "description": "SPEEDRAIL, 1-1/2” X 10'"
    },
    {
      "partNumber": "67450",
      "description": "SPEEDRAIL, 1-1/2” X 12'"
    },
    {
      "partNumber": "67460",
      "description": "SPEEDRAIL, 1-1/2” X 14'"
    },
    {
      "partNumber": "67465",
      "description": "SPEEDRAIL, 1-1/2” X 15'"
    },
    {
      "partNumber": "67470",
      "description": "SPEEDRAIL, 1-1/2” X 16'"
    },
    {
      "partNumber": "67480",
      "description": "SPEEDRAIL, 1-1/2” X 18'"
    },
    {
      "partNumber": "67485",
      "description": "SPEEDRAIL, 1-1/2” X 19'"
    },
    {
      "partNumber": "67490",
      "description": "SPEEDRAIL, 1-1/2” X 20'"
    },
    {
      "partNumber": "67630",
      "description": "STEEL PIPE, 8' "
    },
    {
      "partNumber": "67632",
      "description": "STEEL PIPE, 10' "
    },
    {
      "partNumber": "67635",
      "description": "STEEL PIPE, 12' "
    },
    {
      "partNumber": "67650",
      "description": "STEEL PIPE, 21' "
    },
    {
      "partNumber": "67651",
      "description": "STEEL PIPE, 20'"
    },
    {
      "partNumber": "67680",
      "description": "GAS PIPE, 20' "
    },
    {
      "partNumber": "67682",
      "description": "GAS PIPE, 10'"
    },
    {
      "partNumber": "67690",
      "description": "H-BEAM TROLLEY SYSTEM, 20' "
    },
    {
      "partNumber": "67695",
      "description": "H-BEAM TROLLEY SYSTEM, 30' "
    },
    {
      "partNumber": "67750",
      "description": "ARBOR WEIGHTS"
    },
    {
      "partNumber": "67800",
      "description": "BACKING CLAMP"
    },
    {
      "partNumber": "67840",
      "description": "BRAKE FLOOR BLOCK"
    },
    {
      "partNumber": "67850",
      "description": "BROOM"
    },
    {
      "partNumber": "67900",
      "description": "CHESBOROS FIXED"
    },
    {
      "partNumber": "67950",
      "description": "CHESBOROS SWIVEL"
    },
    {
      "partNumber": "67975",
      "description": "CONDOR LEVELING BLOCKS"
    },
    {
      "partNumber": "67976",
      "description": "CONDOR LEVELING BLOCK / PUSH CART"
    },
    {
      "partNumber": "68050",
      "description": "ELECTRIC HOIST"
    },
    {
      "partNumber": "68075",
      "description": "ENDLESS STRAP"
    },
    {
      "partNumber": "68100",
      "description": "MICROPRESS TABLE"
    },
    {
      "partNumber": "68110",
      "description": "FRAME CORNER, 1” SQUARE TUBE"
    },
    {
      "partNumber": "68111",
      "description": "FRAME TEE, 1” SQUARE PIPE"
    },
    {
      "partNumber": "68200",
      "description": "FORD AXLE (STAKES)"
    },
    {
      "partNumber": "68225",
      "description": "SK BEAM CLAMP"
    },
    {
      "partNumber": "68250",
      "description": "HANGER CHAIN/per ft."
    },
    {
      "partNumber": "68300",
      "description": "HANGER HOOK"
    },
    {
      "partNumber": "68315",
      "description": "20' LADDER BEAM"
    },
    {
      "partNumber": "68350",
      "description": "LUMBER RACK"
    },
    {
      "partNumber": "68390",
      "description": "NEW TRAVELER TRACK 10' SERIES 500"
    },
    {
      "partNumber": "68400",
      "description": "NEW TRAVELER TRACK 20' SERIES 500"
    },
    {
      "partNumber": "68520",
      "description": "TRAVELER TRACK SERIES 500 SWITCHER"
    },
    {
      "partNumber": "68521",
      "description": "500 SERIES CARRIERS"
    },
    {
      "partNumber": "68522",
      "description": "500 SERIES STARTERS"
    },
    {
      "partNumber": "68530",
      "description": "500 SERIES HANGERS"
    },
    {
      "partNumber": "68535",
      "description": "VERLOCKS"
    },
    {
      "partNumber": "68540",
      "description": "PELICAN W/SHACKLE"
    },
    {
      "partNumber": "68550",
      "description": "PICK"
    },
    {
      "partNumber": "68600",
      "description": "PIPE ORGAN CART (W/PIPE INCLUDED)"
    },
    {
      "partNumber": "68625",
      "description": "RAKE"
    },
    {
      "partNumber": "68627",
      "description": "STEEL COME-ALONG"
    },
    {
      "partNumber": "68630",
      "description": "SAFETY RAIL 4'"
    },
    {
      "partNumber": "68635",
      "description": "SAFETY RAIL 8'"
    },
    {
      "partNumber": "68640",
      "description": "SAFETY RAIL BASE - NO RAILS INCLUDED"
    },
    {
      "partNumber": "68650",
      "description": "SAILBOATS "
    },
    {
      "partNumber": "68750",
      "description": "SAILBOATS EXTENSION "
    },
    {
      "partNumber": "68850",
      "description": "SCAFFOLD/GREEN BEDS/per ft."
    },
    {
      "partNumber": "68900",
      "description": "SHELVING BRACKETS"
    },
    {
      "partNumber": "68950",
      "description": "SHOVEL"
    },
    {
      "partNumber": "69000",
      "description": "SLEDGE HAMMER"
    },
    {
      "partNumber": "69050",
      "description": "SPEEDRAIL FITTINGS 1-1/4”"
    },
    {
      "partNumber": "69051",
      "description": "SPEEDRAIL FITTINGS 1-1/2”"
    },
    {
      "partNumber": "69055",
      "description": "SPEED CLIPS"
    },
    {
      "partNumber": "69125",
      "description": "12' UNIBEAMS"
    },
    {
      "partNumber": "69130",
      "description": "LAZY SUSAN ADAMS"
    },
    {
      "partNumber": "69150",
      "description": "WALL JACK W/ 3RD WHEEL"
    },
    {
      "partNumber": "69155",
      "description": "HARGRAVE CLAMP # 1"
    },
    {
      "partNumber": "69156",
      "description": "HARGRAVE CLAMP # 2"
    },
    {
      "partNumber": "69157",
      "description": "HARGRAVE CLAMP # 3"
    },
    {
      "partNumber": "G0100",
      "description": "GRIP TRAILER #1"
    },
    {
      "partNumber": "G0300",
      "description": "GRIP TRAILER #3"
    },
    {
      "partNumber": "G0400",
      "description": "GRIP TRAILER #4"
    },
    {
      "partNumber": "G0500",
      "description": "GRIP TRAILER #5"
    },
    {
      "partNumber": "G0600",
      "description": "GRIP TRAILER #6"
    },
    {
      "partNumber": "G0700",
      "description": "GRIP TRAILER #7"
    },
    {
      "partNumber": "L8001",
      "description": "MVL20 20' MANLIFTB/C"
    },
    {
      "partNumber": "L8001NB",
      "description": "MVL20 20' MANLIFT "
    },
    {
      "partNumber": "L8002",
      "description": "30AM 30' PUSHAROUND"
    },
    {
      "partNumber": "L8003",
      "description": "30AM 30' PUSHAROUND MANLIFT"
    },
    {
      "partNumber": "L8004",
      "description": "36AM 36' PUSHAROUND MANLIFT"
    },
    {
      "partNumber": "L8005",
      "description": "41AM 41' PUSHROUND MANLIFT"
    },
    {
      "partNumber": "L8006",
      "description": "5K WAREHOUSE FORKLIFT"
    },
    {
      "partNumber": "L8007",
      "description": "8K WAREHOUSE FORKLIFT"
    },
    {
      "partNumber": "L8008",
      "description": "6K REACH FORKLIFT"
    },
    {
      "partNumber": "L8009",
      "description": "8K REACH FORKLIFT"
    },
    {
      "partNumber": "L8010",
      "description": "10K REACH FORKLIFT"
    },
    {
      "partNumber": "L8011",
      "description": "12K REACH FORKLIFT"
    },
    {
      "partNumber": "L8011A",
      "description": "12K REACH FORKLIFT/BC"
    },
    {
      "partNumber": "L8101",
      "description": "1930ES  19' SCISSOR LIFTB/C"
    },
    {
      "partNumber": "L8102",
      "description": "2630ES  26' SCISSOR LIFTB/C"
    },
    {
      "partNumber": "L8103-BC",
      "description": "3246ES  32' SCISSOR LIFTB/C"
    },
    {
      "partNumber": "L8104",
      "description": "4069LE  40' SCISSOR LIFT"
    },
    {
      "partNumber": "L8105",
      "description": "43RTS  43' ROUGH TERRAIN SCISSOR LIFT W/ LEVEL"
    },
    {
      "partNumber": "L8106",
      "description": "50RTS 50' ROUGH TERRAIN SCISSOR LIFT W/ LEVEL"
    },
    {
      "partNumber": "L8200",
      "description": "E300AJ 30' ELECTRIC ARTICULATE BOOM"
    },
    {
      "partNumber": "L8201",
      "description": "400S 40' STRAIGHT BOOM"
    },
    {
      "partNumber": "L8202",
      "description": "E400AJ 40' ELECTRIC ARTICULATE BOOM"
    },
    {
      "partNumber": "L8203",
      "description": "E450AJ 45' ARTICULATE ELECTRIC BOOM"
    },
    {
      "partNumber": "L8204",
      "description": "450AJDF 45' DUAL FUEL ARTICULATE BOOM"
    },
    {
      "partNumber": "L8205",
      "description": "600S 60' STRAIGHT BOOM"
    },
    {
      "partNumber": "L8205A",
      "description": "600S STRAIGH BOOM /BC"
    },
    {
      "partNumber": "L8206",
      "description": "600A 60' ARTICULATE BOOM"
    },
    {
      "partNumber": "L8207",
      "description": "800S 80' STRAIGHT BOOM"
    },
    {
      "partNumber": "L8207A",
      "description": "800S 80' STRAIGHT BOOM/BC"
    },
    {
      "partNumber": "L8208",
      "description": "800A 80' ARTICULATE BOOM"
    },
    {
      "partNumber": "L8209",
      "description": "1200S 120' STRAIGHT BOOM"
    },
    {
      "partNumber": "L8210",
      "description": "1350AJ 135' ARTICULATE BOOM"
    },
    {
      "partNumber": "L8211",
      "description": "ANEMOMETER (BLUETOTH)"
    },
    {
      "partNumber": "M5400",
      "description": "LADDER BEAM 10'"
    },
    {
      "partNumber": "M5420",
      "description": "LADDER BEAM 20'"
    },
    {
      "partNumber": "M5500",
      "description": "LEVEL 4'"
    },
    {
      "partNumber": "M5600",
      "description": "3' X 3' LIGHT BOX W/ULTRA BOUNCE"
    },
    {
      "partNumber": "M5650",
      "description": "5' X 5' LIGHT BOX W/ULTRA BOUNCE"
    },
    {
      "partNumber": "M5700",
      "description": "4' X 4' LIGHT BOX W/ULTRA BOUNCE"
    },
    {
      "partNumber": "M5750",
      "description": "4' X 8' LIGHT BOX W/ULTRA BOUNCE"
    },
    {
      "partNumber": "M7800",
      "description": "SANDBOX"
    },
    {
      "partNumber": "M9000",
      "description": "TEASER 8' X 20'"
    },
    {
      "partNumber": "N1000",
      "description": "CROSS #7E 1-1/4”"
    },
    {
      "partNumber": "N1020",
      "description": "CROSS #10 1-1/4”"
    },
    {
      "partNumber": "N1050",
      "description": "CROSS ADJUSTABLE #21 1-1/4”"
    },
    {
      "partNumber": "N1100",
      "description": "CROSS SLIDE-OUTLET #13E 1-1/4”"
    },
    {
      "partNumber": "N1125",
      "description": "CROSS MODIFIED 1-1/4”"
    },
    {
      "partNumber": "N1150",
      "description": "CROSS SHORT 1-1/4”"
    },
    {
      "partNumber": "N1165",
      "description": "CROSS SIDE-OUT #104-7 1-1/4”"
    },
    {
      "partNumber": "N1175",
      "description": "CROSS SPLIT 1-1/4”"
    },
    {
      "partNumber": "N1180",
      "description": "OUTSIDE CORNER #2O 1-1/4”"
    },
    {
      "partNumber": "N1185",
      "description": "SPEEDRAIL COUPLER (SHORT) 1-1/4”"
    },
    {
      "partNumber": "N2000",
      "description": "ELBOW #3 1-1/4”"
    },
    {
      "partNumber": "N2010",
      "description": "ELBOW ADJUSTABLE #3AE 1-1/4”"
    },
    {
      "partNumber": "N2060",
      "description": "ELBOW SIDE-OUT #9 1-1/4”"
    },
    {
      "partNumber": "N3000",
      "description": "FLANGE #50 1-1/4”"
    },
    {
      "partNumber": "N3005",
      "description": "WALL FLANGE #52 (HORIZONTAL) 1-1/4”"
    },
    {
      "partNumber": "N3080",
      "description": "FLANGE UPRIGHT #45 1-1/4”"
    },
    {
      "partNumber": "N3100",
      "description": "FLANGE ADJUSTALE #41 1-1/4”"
    },
    {
      "partNumber": "N3200",
      "description": "RACKETMASTER #102 1-1/4”"
    },
    {
      "partNumber": "N3300",
      "description": "RAIL POST #30C-7 1-1/4”"
    },
    {
      "partNumber": "N3500",
      "description": "TEE ADJUSTABLE #17 1-1/4”"
    },
    {
      "partNumber": "N3520",
      "description": "TEE #5 1-1/4”"
    },
    {
      "partNumber": "N3540",
      "description": "TEE SHORT #5E 1-1/4”"
    },
    {
      "partNumber": "N3560",
      "description": "TEE SIDE-OUT #11 1-1/4”"
    },
    {
      "partNumber": "N3580",
      "description": "TEE SWIVEL 1-1/4”"
    },
    {
      "partNumber": "N3600",
      "description": "SPLIT TEE #2 1-1/4”"
    },
    {
      "partNumber": "N4200",
      "description": "CROSS #7E 1-1/2”"
    },
    {
      "partNumber": "N4220",
      "description": "CROSS #10 1-1/2”"
    },
    {
      "partNumber": "N4240",
      "description": "CROSS ADJUSTABLE #21 1-1/2”"
    },
    {
      "partNumber": "N4260",
      "description": "CROSS SLIDE-OULET 1-1/2”"
    },
    {
      "partNumber": "N4280",
      "description": "CROSS MODIFIED 1-1/2”"
    },
    {
      "partNumber": "N4300",
      "description": "CROSS SHORT 1-1/2”"
    },
    {
      "partNumber": "N4320",
      "description": "CROSS SIDE-OUT #104-7 1-1/2”"
    },
    {
      "partNumber": "N4340",
      "description": "CROSS SPLIT 1-1/2”"
    },
    {
      "partNumber": "N4360",
      "description": "OUTSIDE CORNER #20 1-1/2”"
    },
    {
      "partNumber": "N4400",
      "description": "SPEEDRAIL COUPLER (SHORT) 1-1/2”"
    },
    {
      "partNumber": "N4420",
      "description": "ELBOW #3 1-1/2”"
    },
    {
      "partNumber": "N4440",
      "description": "ELBOW ADJUSTABLE #3AE 1-1/2”"
    },
    {
      "partNumber": "N4460",
      "description": "ELBOW SIDE-OUT #9 1-1/2”"
    },
    {
      "partNumber": "N4500",
      "description": "FLANGE #50 1-1/2”"
    },
    {
      "partNumber": "N4520",
      "description": "FLANGE #52 1-1/2”"
    },
    {
      "partNumber": "N4560",
      "description": "FLANGE UPRIGHT #45 1-1/2”"
    },
    {
      "partNumber": "N4580",
      "description": "FLANGE ADJUSTABLE #41 1-1/2”"
    },
    {
      "partNumber": "N4600",
      "description": "RACKETMASTER #102 1-1/2”"
    },
    {
      "partNumber": "N4650",
      "description": "RAIL POST #30C-7 1-1/2”"
    },
    {
      "partNumber": "N4700",
      "description": "TEE ADJUSTABLE #17 1-1/2”"
    },
    {
      "partNumber": "N4720",
      "description": "TEE #5 1-1/2”"
    },
    {
      "partNumber": "N4730",
      "description": "TEE SHORT #5 1-1/2”"
    },
    {
      "partNumber": "N4750",
      "description": "TEE SIDE-OUT #11 1-1/2”"
    },
    {
      "partNumber": "N4770",
      "description": "TEE SWIVEL 1-1/2”"
    },
    {
      "partNumber": "N4800",
      "description": "SPLIT TEE #2 1-1/2”"
    },
    {
      "partNumber": "P2000",
      "description": "18” X 48” REFASIL"
    },
    {
      "partNumber": "P2550",
      "description": "24” X 48” POLY SILK"
    },
    {
      "partNumber": "P2555",
      "description": "24” X 48” BLACK POLY SILK"
    },
    {
      "partNumber": "P2560",
      "description": "24” X 36” CHINA SILK"
    },
    {
      "partNumber": "P2565",
      "description": "24” X 48” 1/4 SILK"
    },
    {
      "partNumber": "P2570",
      "description": "24” X 48” BLACK CHINA SILK"
    },
    {
      "partNumber": "R0205",
      "description": "8' X 12' DAY BLUE"
    },
    {
      "partNumber": "R0210",
      "description": "8' X 12' SOFT FROST"
    },
    {
      "partNumber": "R0215",
      "description": "8' X 12' 1/2 SOFT FROST"
    },
    {
      "partNumber": "R0220",
      "description": "8' X 12' FULL GRID"
    },
    {
      "partNumber": "R0225",
      "description": "8' X 12' 1/2 GRID"
    },
    {
      "partNumber": "R0230",
      "description": "8' X 12' 1/4 GRID"
    },
    {
      "partNumber": "R0235",
      "description": "8' X 12' BLACK GRID"
    },
    {
      "partNumber": "R0240",
      "description": "8' X 12' MAGIC CLOTH"
    },
    {
      "partNumber": "R0245",
      "description": "8' X 12' MUSLIN BLEACHED"
    },
    {
      "partNumber": "R0250",
      "description": "8' X 12' UNBLEACHED MUSLIN"
    },
    {
      "partNumber": "R0255",
      "description": "8' X 12' POLY SILK"
    },
    {
      "partNumber": "R0260",
      "description": "8' X 12' SILVER LAME"
    },
    {
      "partNumber": "R0265",
      "description": "8' X 12' SOLID"
    },
    {
      "partNumber": "R0268",
      "description": "8' X 12' ULTRA BLACK"
    },
    {
      "partNumber": "R0270",
      "description": "8' X 12' ULTRA BOUNCE"
    },
    {
      "partNumber": "R0280",
      "description": "8' X 12' WHITE DUVATYNE"
    },
    {
      "partNumber": "R0305",
      "description": "8' X 16' MAGIC CLOTH"
    },
    {
      "partNumber": "R0650",
      "description": "12' X 25” 1/2 SILENT GRID"
    },
    {
      "partNumber": "R0660",
      "description": "12' X 25' 1/4 GRID"
    },
    {
      "partNumber": "R0705",
      "description": "12' X 30' DAY BLUE"
    },
    {
      "partNumber": "R0710",
      "description": "12' X 30' NITE BLUE"
    },
    {
      "partNumber": "R0715",
      "description": "12' X 30' CHROMA BLUE (POLY PRO)"
    },
    {
      "partNumber": "R0720",
      "description": "12' X 30' CHROMA GREEN (POLY PRO)"
    },
    {
      "partNumber": "R0725",
      "description": "12' X 30' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "R0730",
      "description": "12' X 30' DIGITAL GREEN"
    },
    {
      "partNumber": "R0735",
      "description": "12' X 30' DUVATYNE"
    },
    {
      "partNumber": "R0740",
      "description": "12' X 30' DAY GRAY"
    },
    {
      "partNumber": "R0745",
      "description": "12' X 30' NITE GRAY"
    },
    {
      "partNumber": "R0750",
      "description": "12' X 30' FULL GRID CLOTH SILENT"
    },
    {
      "partNumber": "R0760",
      "description": "12' X 30' 1/2 SILENT GRID"
    },
    {
      "partNumber": "R0770",
      "description": "12' X 30' 1/4 GRID CLOTH CRUNCHY"
    },
    {
      "partNumber": "R0775",
      "description": "12' X 30' BLEACHED MUSLIN"
    },
    {
      "partNumber": "R0785",
      "description": "12' X 30' ULTRA BLACK"
    },
    {
      "partNumber": "R0790",
      "description": "12' X 30' UTLRA BOUNCE"
    },
    {
      "partNumber": "R0795",
      "description": "12' X 30' BLACK VELVET"
    },
    {
      "partNumber": "R0800",
      "description": "12' X 30' WATER SOLID"
    },
    {
      "partNumber": "R0905",
      "description": "12' X 40' DAY BLUE"
    },
    {
      "partNumber": "R0910",
      "description": "12' X 40' NITE BLUE"
    },
    {
      "partNumber": "R0925",
      "description": "12' X 40' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "R0930",
      "description": "12' X 40' DIGITAL BLUE (TEMPO)"
    },
    {
      "partNumber": "R0935",
      "description": "12' X 40' DUVATYNE"
    },
    {
      "partNumber": "R0940",
      "description": "12' X 40' DAY GRAY"
    },
    {
      "partNumber": "R0960",
      "description": "12' X 40' 1/2 SILENT GRID"
    },
    {
      "partNumber": "R0975",
      "description": "12' X 40' BLEACHED MUSLIN"
    },
    {
      "partNumber": "R0990",
      "description": "12' X 40' ULTRABOUNCE"
    },
    {
      "partNumber": "R1205",
      "description": "12' X 50' DAY BLUE"
    },
    {
      "partNumber": "R1230",
      "description": "12' X 50' DIGITAL GREEN"
    },
    {
      "partNumber": "R1235",
      "description": "12' X 50' DUVATYNE"
    },
    {
      "partNumber": "R1275",
      "description": "12' X 50' BLEACHED MUSLIN"
    },
    {
      "partNumber": "R1280",
      "description": "12' X 50' BLEACHED MUSLIN SEAMLESS"
    },
    {
      "partNumber": "R1360",
      "description": "12' X 60' DUVATYNE"
    },
    {
      "partNumber": "R1405",
      "description": "12' X 70' DAY BLUE"
    },
    {
      "partNumber": "R1505",
      "description": "12' X 80' DAY BLUE"
    },
    {
      "partNumber": "R1530",
      "description": "12' X 80' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "R1630",
      "description": "12' X 100' DIGITAL GREEN"
    },
    {
      "partNumber": "R1800",
      "description": "14' X 29' WATER SOLID"
    },
    {
      "partNumber": "R1930",
      "description": "14' X 60' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "R2530",
      "description": "15' X 30' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "R2580",
      "description": "15' X 40' DAY BLUE"
    },
    {
      "partNumber": "R2590",
      "description": "15' X 40' DUVATYNE"
    },
    {
      "partNumber": "R2630",
      "description": "15' X 60' DIGITAL BLUE (TEMPO)"
    },
    {
      "partNumber": "R2830",
      "description": "15' X 70' DIGITAL BLUE"
    },
    {
      "partNumber": "R3225",
      "description": "15' X 80' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "R3230",
      "description": "15' X 80' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "R3315",
      "description": "15' X 100' DIGITIAL GREEN"
    },
    {
      "partNumber": "R3415",
      "description": "15.6' X 80' CHROMA BLUE (POLY PRO)"
    },
    {
      "partNumber": "R5030",
      "description": "16' X 32' DIGITAL GREEN"
    },
    {
      "partNumber": "R7630",
      "description": "25' X 60' CHROMA BLUE (POLY PRO)"
    },
    {
      "partNumber": "R8485",
      "description": "31' X 100' CHROMAKEY GREEN (POLY PRO)"
    },
    {
      "partNumber": "R8575",
      "description": "32' X 80' CHROMAKEY BLUE (POLY PRO)"
    },
    {
      "partNumber": "R8710",
      "description": "32' X 100' CHROMAKEY BLUE (POLY PRO)"
    },
    {
      "partNumber": "R8730",
      "description": "32' X 100' DIGITAL BLUE (POLY PRO)"
    },
    {
      "partNumber": "R8760",
      "description": "32' X 140' CHROMA GREEN (POLY PRO)"
    },
    {
      "partNumber": "R8980",
      "description": "34' X 100' DIGITAL GREEN (POLY PRO)"
    },
    {
      "partNumber": "R9025",
      "description": "34' X 120' DIGITAL GREEN (POLY PRO)"
    }
   ];
  constructor() { }
  getItems() {
    return this.items;
  }
}
